
	const utils         	= require('./utils')
	const CONSTANTS 		= require('./constants')
	const appConfig       	= require('./config').getConfig()
	const componentList   	= require('./componentList')
	const Component       	= require('./component')


	function ComponentTree(){
		// TODO: DEBUG CLEANUP START
		this.prepareLeafs = 0;
		// TODO: DEBUG CLEANUP END

		// this is the next available component index used within client-side code only
		this.componentIndex = 0;
		// this is the next available tab index used within client-side code only
		this.tabIndex = 0;
		// this is a list of tab index-lists which has been assigned to components. the keys of the tab index-lists are their focusPriority values.
		this.tabIndexRegister = {};
		// if local filesystem shadow components are built all children have to get a componentInstance. this index is the next available one.
		this.globalShadowComponentInstanceIndex = 0;
		// prepared list of global actions (loaded via filesystem) by scope (or ~ without any scope)
		this.globalActionsByScope = {}
		// prepared list of global shadows (loaded via filesystem) by scope (or ~ without any scope)
		this.globalShadowsByScope = {}
		// check if autofocus is granted
		this.grantAutoFocus = true;
		// masterComponent in control of autofocus grant state
		this.grantAutoFocusMasterComponentIndex = 0;
		// this flag is used to save a client-side only lookup list of all attached components accessible by this.componentIndex.
		// NOTE = also subComponents will be registered client-side according to their subComponentIndex (idSuffix extended) by component.createSubComponent()
		this.lookup = {};
		// this flag is used to save a component mapping accessible by the component instance id (like lookup)
		this.mapping = {};
		/**
		 * this flag is used to save a shadow component mapping accessible by the component instance id of the following form:
		 * 		{
		 * 			<componentInstanceID>: {
		 * 				scope: <scope>,
		 * 				scopeRoleVersions: {
		 * 					<scopeRoleID>: <shadowComponentLeaf>,
		 * 					...
		 * 				}
		 * 			},
	 	 * 			...
		 * 		}
 		 */
		this.shadowMapping = {};
		// this flag is used to save the route-identification-properties to a given key <path|routeTemplateMappingKey> => {
		// 		<routeID>
		// 		<path>
		// 		<corePath>
		// 		<routeParams>
		// 		<routeParamsExtension>
		// 		<routeTemplateCodeName>
		// 		<routeTemplateLangCode>
		// }
		// this mapping is cms_routes.routeParamsExtension dependent and should prevent multiple copies of rawTrees, trees and so on according to different routeParams
		this.routeIdentificationMapping = {};
		// this flag is used to save all raw trees at server runtime which are received by the api
		this.rawTrees = {};
		// this flag is used to save all built trees at server runtime
		this.trees = {};
		// this flag is used to save all ready for browser rendered html trees
		this.html = {};
		// this list will be filled with components which cannot be destroyed at the moment because of still running actions
		this.deadHeads = [];
		// this is very similar to the lookup list but container only a plain list of components (componentIndex is used as key)
		// of all components which are dependent on their global environment. (e.g., like window size, used device, ...)
		// furthermore,  this lookup will only be used on client-side.
		this.environmentDependentLookup = {};
		// this list is filled by the client with components which wants to react on the actual environment-changed-event when all components are ready.
		this.environmentChangeLookup = {};
		// how many environment dependent components have been registered to be refreshed within one environment-changed-event.
		this.environmentChangeRegistered = 0;
		// TODO = DOC!
		// TODO: CLEANUP?
		// this.links = {};
		// this flag is used to store handlers of components according to their handle-names
		this.handlers = {};
	}

	/**
	 * returns the next available component-index
	 * @return int
	 */
	ComponentTree.prototype.getNextIndex = function(){
		return ++this.componentIndex;
	};

	/**
	 * returns the next available tab-index
	 *
	 * @param   focusPriority       int - focusPriority
	 * @return  int
	 */
	ComponentTree.prototype.getNextTabIndex = function(focusPriority){
		if(!this.tabIndexRegister[focusPriority]) this.tabIndexRegister[focusPriority] = {};
		this.tabIndexRegister[focusPriority][++this.tabIndex] = true;
		return this.tabIndex;
	};

	/**
	 * this function chooses the right component according to the tabIndex register and sets the focus
	 */
	ComponentTree.prototype.focusRightComponent = function(){
		if(!this.grantAutoFocus || document.hidden || !document.hasFocus()) return;
		var self = this;
		var maxPriority = -1;
		var maxTabIndex = -1;
		var tabIndex, priority, componentIndex, component, focusElement;
		var attributes;
		$('[tabIndex]').each(function(elementIndex, element){
			if(
				(attributes = (element.attributes || {})) &&
				(tabIndex = parseInt((attributes.tabIndex || {}).nodeValue)) &&
				(componentIndex = parseInt((attributes['data-component-index'] || {}).nodeValue)) &&
				(component = self.lookup[componentIndex]) &&
				$(element).is(':visible')
			){
				priority = component.config.focusPriority || 0;
				if(priority > maxPriority || (priority == maxPriority && tabIndex > maxTabIndex)){
					maxPriority = priority;
					maxTabIndex = tabIndex;
					focusElement = element;
				}
			}
		});

		var $focusElement;
		if(focusElement && ($focusElement = $(focusElement)).length > 0){
			$focusElement.focus();
		}
	};

	/**
	 * this function is used to call a global registered handler.
	 *
	 * @param callerComponent       Component - the component which has performed this call.
	 * @param handlerName           string - name of the handler
	 * @param args                  array - optional array which can contain args for the handle
	 */
	ComponentTree.prototype.callHandler = function(callerComponent, handlerName, args){
		var self = this;
		args = args || [];
		if(handlerName !== undefined && !utils.isEmpty(this.handlers[handlerName])){
			utils.forEach(self.handlers[handlerName], function(handler){
				// should this handler be performed according to the given component class?
				if(handler && (utils.isEmpty(handler.componentClass) || callerComponent instanceof Component && callerComponent.hasClass(handler.componentClass))){
					var handleArguments = args.length > 0 ? utils.copy(args) : [];
					handleArguments.unshift(callerComponent);
					if(self.lookup[handler.calleeComponentIndex]){
						handler.handle.apply(self.lookup[handler.calleeComponentIndex], handleArguments);
					}
					else {
						// throw new ClientError('CALLEE_COMPONENT_NOT_FOUND_FOR_HANDLER', 'a handler without a valid callee component is a real problem... calleeComponentIndex: ' + handler.calleeComponentIndex, CONSTANTS.ERROR.LEVEL.ERROR);
						throw new Error('a handler without a valid callee component is a real problem... calleeComponentIndex: ' + handler.calleeComponentIndex);
					}
				}
			});
		}
	};

	/**
	 * register component which is not able to die at the moment because of still running actions.
	 *
	 * @param   bossComponentIndex  int - componentIndex of bossComponent which is responsible that the deadHead was not ready to die.
	 * @param   componentIndex      int - components' componentIndex
	 */
	ComponentTree.prototype.iAmNotReadyToDie = function(bossComponentIndex, componentIndex){
		if(bossComponentIndex == undefined || componentList == undefined) return;
		this.deadHeads[componentIndex] = bossComponentIndex;
	};

	/**
	 * try to kill all known deadHeads.
	 *
	 * @param   bossComponentIndex  int - componentIndex of bossComponent which is responsible that the deadHead was not ready to die.
	 */
	ComponentTree.prototype.killingSpree = function(bossComponentIndex){
		if(bossComponentIndex == undefined) return;

		for(var componentIndex in this.deadHeads){
			if(this.lookup[componentIndex] && this.deadHeads[componentIndex] == bossComponentIndex){
				this.lookup[componentIndex].destroy();
				delete this.deadHeads[componentIndex];
			}
		}
	};

	/**
	 * this function is used to call a global registered handler.
	 * NOTE: this function must not be called server-side.
	 *
	 * @params  storage                     object - actual storage
	 * @params  initialClientExecution      boolean - is this the initial execution by client?
	 * @params  serverKnownEnvironment      object - this flag contains the environment which is known by the server
	 * @params  externalDrivenCall          boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
	 */
	ComponentTree.prototype.onEnvironmentChange = function(storage, initialClientExecution, serverKnownEnvironment, externalDrivenCall){
		// init
		var self = this;
		var environmentOptions = {};
		var refreshComponents = {};
		if(storage) environmentOptions = storage.user.data.environment;

		// check if someone wants to be refreshed
		utils.forEach(this.environmentDependentLookup, function(component, componentIndex){
			if(component.checkEnvironment(environmentOptions, serverKnownEnvironment, initialClientExecution, externalDrivenCall) === true){
				self.environmentChangeLookup[componentIndex] = -1;
				refreshComponents[componentIndex] = true;
			}
		});

		// tell all components the new environment
		utils.forEach(this.lookup, function(component, componentIndex){
			self.lookup[componentIndex].activeEnvironment = utils.simpleCopy(environmentOptions);
		});

		// refresh those components which want to be refreshed
		// NOTE: this is called separately to prevent refresh operations on the old environments.
		var componentIndex;
		for(componentIndex in refreshComponents){
			if(self.lookup[componentIndex]){
				self.lookup[componentIndex].refresh(false, { environmentChanged: true, environment: environmentOptions, serverKnownEnvironment: serverKnownEnvironment, externalDrivenCall: externalDrivenCall, initialClientExecution: initialClientExecution });
			} else {
				console.error(`ComponentTree.onEnvironmentChange() refresh not possible cause component does not exist any longer @ ${componentIndex}`)
			}
		}

		// tell all environment dependent components which want to know that the environment has been updated
		utils.forEach(this.environmentDependentLookup, function(component, componentIndex){
			if(typeof(component.onEnvironmentUpdated) === 'function') component.onEnvironmentUpdated();
		});
	};

	/**
	 * this function is used to register a component as ready to finalize its environmental change.
	 * NOTE: the finalize call depends on all components which have been registered and if their preloading-files has been loaded or not.
	 *
	 * @param   component           Component - component which wants to be registered
	 * @param   nrOfLoadingFiles    int - number of files which we have to wait for.
	 * @param   insertImmediatly    boolean - should the dom operation be finalized immediately. in case of inclusions important.
	 */
	ComponentTree.prototype.registerEnvironmentChange = function(component, nrOfLoadingFiles, insertImmediatly){
		// init
		if(!component) return;
		var componentIndex = component.componentIndex;
		if(componentIndex === undefined) return;

		// force single finalize (e.g., in case of inclusions)
		if(insertImmediatly){
			delete this.environmentChangeLookup[componentIndex];
			component.finalizeEnvironmentChange();
		}
		else {

			// wait for others to finalize
			nrOfLoadingFiles = nrOfLoadingFiles || 0;
			if(this.environmentChangeLookup[componentIndex] == undefined) {
				// register normal refresh- or include-elements
				this.environmentChangeLookup[componentIndex] = -1;
			}

			if(nrOfLoadingFiles == 0 && this.environmentChangeLookup[componentIndex] != 0){
				this.environmentChangeRegistered++;

				if(this.environmentChangeRegistered == utils.collectionSize(this.environmentChangeLookup)){
					// finalize environment changes on all registered components
					var self = this;
					// NOTE: this copy is used to prevent race-conditions
					// TODO: theoretically it is possible to receive another race-condition within the next 3 lines
					var environmentChangeLookup = utils.simpleCopy(this.environmentChangeLookup);
					// reset lookup and register
					this.environmentChangeLookup = {};
					this.environmentChangeRegistered = 0;
					utils.forEach(environmentChangeLookup, function(nrOfLoadingFiles, componentIndex){
						if(self.lookup[componentIndex]){
							self.lookup[componentIndex].finalizeEnvironmentChange();
						}
					});
				}
				else {
					this.environmentChangeLookup[componentIndex] = 0;
				}
			}
			else {
				this.environmentChangeLookup[componentIndex] = nrOfLoadingFiles;
			}
		}
	};

	/**
	 * this function is used to trigger a hook.
	 * this is only possible on client-side, because events and hooks are not working without a dom.
	 *
	 * @param leaf                  {} | int - leaf data or leaf componentIndex
	 * @param triggerName           string - name of trigger
	 * @param hookOptions           object - options given to the hook
	 * @param recursive             boolean - should the hook be triggered for all leaf.children
	 * @param attachTrigger         object - context object used to store promises needed to manage attach- and postAttach-phases.
	 */
	ComponentTree.prototype.trigger = async function(leaf, triggerName, hookOptions, recursive, attachTrigger){
		// init
		if(typeof(recursive) === 'undefined')                           recursive = false;
		if(utils.isString(leaf) || utils.isNumber(leaf))  				leaf = this.lookup[leaf];
		else if(typeof(leaf) === 'undefined')                           leaf = this.lookup[Object.keys(this.lookup)[0]];
		if(typeof(hookOptions) === 'undefined')                         hookOptions = {};

		await this.triggerLeaf(leaf, triggerName, hookOptions, recursive, attachTrigger);
	};

	/**
	 * this function is used to trigger a hook of a leaf.
	 * this is only possible on client-side, because events and hooks are not working without a dom.
	 *
	 * @param leaf                  object - leaf data
	 * @param triggerName           string - name of trigger
	 * @param hookOptions           object - options given to the hook
	 * @param recursive             boolean - should the hook be triggered for all leaf.children
	 * @param attachTrigger         object - context object used to store promises needed to manage attach- and postAttach-phases.
	 */
	ComponentTree.prototype.triggerLeaf = async function(leaf, triggerName, hookOptions, recursive, attachTrigger){
		// prevent errors according to erroneous leaf definitions
		if(utils.isCollection(leaf)){
			if(leaf.type === 'component' || leaf.type === 'section' || leaf.type === 'route'){

				// set right tab index if necessary
				// TODO: really every trigger?!?
				if(leaf.type === 'component' && leaf.config && leaf.config.focusAble){
					leaf.config.tabIndex = this.getNextTabIndex(leaf.config.focusPriority || 0)
				}

				// early descending if necessary
				if(recursive){
					for(const child of Object.values(leaf.children)){
						await this.triggerLeaf(child, triggerName, hookOptions, recursive, attachTrigger)
					}
				}

				if(leaf.type === 'component'){
					// trigger hook
					await leaf.trigger(triggerName, hookOptions, attachTrigger)
				}
			}
			else {
				// TODO: throw error?
			}
		}
	};

	/**
	 * this method is used to execute functions of leafs according to the tree structure.
	 * e.g., <someComponent>.prepare() will be called like this.
	 * sometimes recursion is desired, sometimes the first depth-level of leafs should not be left.
	 *
	 * @param leaf					object - componentTree-leaf
	 * @param methodName			string - method name to execute
	 * @param methodOptions			object - options which should be presented to the function call as params
	 * 								NOTE: granted keys are: storage, isServer [default: false] and options
	 * @param recursive				boolean - default: false - should all leafs within the tree be checked?
	 * 								if so it will be an early descending recursion.
	 */
	ComponentTree.prototype.executeOn = function(leaf, methodName, methodOptions, recursive){
		// init
		if(typeof(recursive) === 'undefined')                           recursive = false;
		if(typeof(methodOptions) === 'undefined')                       methodOptions = {};

		if(methodName && leaf){
			this.executeOnLeaf(leaf, methodName, methodOptions, recursive);
		}
	};

	/**
	 * this method is used to execute a function of a leaf.
	 * e.g., <someComponent>.prepare() will be called like this.
	 * sometimes recursion is desired, sometimes the first depth-level of leafs should not be left.
	 *
	 * @param leaf					object - componentTree-leaf
	 * @param methodName			string - method name to execute
	 * @param methodOptions			object - options which should be presented to the function call as params
	 * 								NOTE: granted keys are: storage, isServer [default: false] and options
	 * @param recursive				boolean - default: false - should all leafs within the tree be checked?
	 * 								if so it will be an early descending recursion.
	 */
	ComponentTree.prototype.executeOnLeaf = function(leaf, methodName, methodOptions, recursive){
		var self = this;

		// prevent errors according to erroneous leaf definitions
		if(utils.isCollection(leaf)){
			if(leaf.type === 'component' || leaf.type === 'section' || leaf.type === 'route'){

				// early descending if necessary
				if(recursive){
					utils.forEach(leaf.children || [], function(child){
						self.executeOnLeaf(child, methodName, methodOptions, recursive);
					});
				}

				if(leaf.type === 'component' && typeof(leaf[methodName]) === 'function'){
					// execute method
					leaf[methodName].apply(leaf, [methodOptions.storage, methodOptions.isServer || false, methodOptions.options || {}]);
				}
			}
		}
	};

	/**
	 * invoke given callback with the following arguments: leaf, callbackOptions, leafIndex, tree
	 * for each component within given leaf (or tree) inclusive the given leaf itself.
	 *
	 * @param leaf						object - leaf or tree
	 * @param recursive					boolean - if false only the actual given leaf will be checked
	 * @param callback					function - callback(leaf, callbackOptions, leafIndex, tree)
	 * @param callbackOptions			mixed - callback options
	 * @param childrenContainerName		string - default: children - children || relationships
	 * @param leafIndex					mixed -	actual leafIndex
	 * @param reversed					boolean - default: false - should be iterated in a reverse manner?
	 * @param lateDecending				boolean - default: false - should be used early- or late-descending?
	 * @param grantAllLeafTypes			boolean - by default only components are granted - if this flag is set to true, routes and sections will get called by the callback too.
	 * @param tree						mixed - the parent object of the given leaf. only necessary if it should be useable within the callback function (e.g., for deletions).
	 */
	ComponentTree.prototype.forEachLeaf = function(leaf, recursive, callback, callbackOptions, childrenContainerName, leafIndex, reversed, lateDecending, grantAllLeafTypes, tree){
		var self = this;
		childrenContainerName = childrenContainerName || 'children';

		// prevent errors according to erroneous leaf definitions
		if(utils.isCollection(leaf) && callback){
			if(leaf.type === 'component' || leaf.type === 'section' || leaf.type === 'route'){

				// early descending if necessary
				if(recursive && !lateDecending){
					if(reversed){
						utils.forEachReverse(leaf[childrenContainerName] || [], function(child, childIndex){
							// NOTE: be sure to call children by reference
							self.forEachLeaf(leaf[childrenContainerName][childIndex], recursive, callback, callbackOptions, childrenContainerName, childIndex, reversed, lateDecending, grantAllLeafTypes, leaf[childrenContainerName]);
						});
					} else {
						utils.forEach(leaf[childrenContainerName] || [], function(child, childIndex){
							// NOTE: be sure to call children by reference
							self.forEachLeaf(leaf[childrenContainerName][childIndex], recursive, callback, callbackOptions, childrenContainerName, childIndex, reversed, lateDecending, grantAllLeafTypes, leaf[childrenContainerName]);
						});
					}
				}

				// execute callback
				if(leaf.type === 'component' || grantAllLeafTypes){
					callback(leaf, callbackOptions, leafIndex, tree)
				}

				// late decending if necessary
				if(recursive && lateDecending){
					if(reversed){
						utils.forEachReverse(leaf[childrenContainerName] || [], function(child, childIndex){
							// NOTE: be sure to call children by reference
							self.forEachLeaf(leaf[childrenContainerName][childIndex], recursive, callback, callbackOptions, childrenContainerName, childIndex, reversed, lateDecending, grantAllLeafTypes, leaf[childrenContainerName]);
						});
					} else {
						utils.forEach(leaf[childrenContainerName] || [], function(child, childIndex){
							// NOTE: be sure to call children by reference
							self.forEachLeaf(leaf[childrenContainerName][childIndex], recursive, callback, callbackOptions, childrenContainerName, childIndex, reversed, lateDecending, grantAllLeafTypes, leaf[childrenContainerName]);
						});
					}
				}
			}
		}
	}

	/**
	 * this function is used to prepare / normalize the leaf data in order to keep the component code and the data which has to be transmitted small
	 *
	 * @param   leaf                        	object - leaf (component data)
	 * @param   parentRoutePath             	string - path to parent route element
	 * @param   parentRouteID               	int - actual parentRouteID
	 * @param   parentComponentIndex        	string - id of parent component or empty string in case of root component
	 * @param   parentComponentInstanceID   	int - id of parent component
	 * @param   parentRouteActions				object - optional - if parentRouteActions are defined they should be available within the child-leafs of the route
	 * @param   isRootTree                  	boolean - this flag is set to true if the actual tree is the tree which will be rendered if the browser will request an url. this fact is not met if the browser requests a tree to load it into a section.
	 * @param   isBaseInit                  	boolean - should the components be normalized or not
	 * @param   isBrowser                   	boolean
	 * @param   storage                     	object - actual storage
	 * @param   environment                 	object - actual known environment
	 * @param   buildAborted                	boolean - has the parent leaf been aborted according to status, privilegeCode or one of the periods
	 * @param   resourceDependencyParent    	int - this flag is set if the actual component has a resource dependency of one of its' parent components.
	 *                                      	if the flag is not undefined it contains the corresponding parent components' componentIndex.
	 * @param   resourceLoaders             	object - actual resourceLoaders
	 * @param   resourceLoadersUsesOwnService 	boolean - should the resourceLoaders added by this build process use the own (true) or the foreign (false) service to load data by default (if not defined within a fieldConfig)?
	 * 											default: true
	 * @param   prepareModelData            	boolean - this flag decides if the model has to be prepared (atom to flag transformation) or not.
	 * @param   parentRouteData             	object - the route-components' data which has to be copied to the underlying layout-component (model, actions, ...)
	 * @param   parentLeafInfo 				object - the parent-routes' information needed for inheritance- and miscellanious-features (e.g., scope)
	 * @param 	inclusionComponentIndex	   		boolean - predefined action components or inclusion components will should set this parameter to true (this special components' indexes does exist only on the client will be set negative)
	 * @param   isShadowOrChildOfOne			boolean - optional - isShadowComponent or a child of one (directly or indirectly)
	 * @param   parentPostponesChildren			boolean - optional - if this is set to true only necessary extractions would be performed on the actual leaf and its children. (e.g., shadow components or action definitions would be registered).
	 * 											this is useful if a component will never be rendered on the server but should be built in the fec-client. e.g., base_form_relationship children for event.registrationForm.
	 * @returns Component                   	prepared leaf
	 */
	ComponentTree.prototype.prepareLeaf = function(leaf, parentRoutePath, parentRouteID, parentComponentIndex, parentComponentInstanceID, parentRouteActions, isRootTree, isBaseInit, isBrowser, storage, environment, buildAborted, resourceDependencyParent, resourceLoaders, resourceLoadersUsesOwnService, prepareModelData, parentRouteData, parentLeafInfo, inclusionComponentIndex, isShadowOrChildOfOne, parentPostponesChildren){
		this.prepareLeafs++;

		// init some defaults
		if(typeof(leaf.type) === 'undefined') 	leaf.type = 'component';
		if(typeof(leaf.subType) === 'undefined') leaf.subType = null;

		// init
		const self             		= this;
		const isObject						= typeof(leaf) === 'object';
		const isRoute                     	= (isObject && leaf.type === 'route');
		const isSection                     = (isObject && leaf.type === 'section');
		const isComponent                   = (isObject && leaf.type === 'component');
		const isGlobalShadowContainer       = (isObject && leaf.type === 'globalShadowContainer');
		const isShadowComponent             = isComponent && !utils.isEmpty(leaf.config) && !utils.isEmpty(leaf.config.isShadowComponent);
		const wasShadowComponent            = isComponent && !utils.isEmpty(leaf.config) && !utils.isEmpty(leaf.config.wasShadowComponent);
		const isInitializedShadowComponent  = isShadowComponent && !utils.isEmpty(leaf.componentIndex);

		// is route
		if(isRoute){
			// set parentComponentInstanceID whenever possible (e.g., used for shadow component locating - so it is not necessarily a problem if more than one component instance within the client have the same componentInstanceID)
			if(parentComponentInstanceID !== undefined) leaf.parentComponentInstanceID = parentComponentInstanceID;
		}
		// is section
		else if(isSection){
			if(!isBrowser && !leaf.sectionID){
				leaf.sectionID = `GSS${this.globalShadowComponentInstanceIndex++}`
			}
		}
		// is component
		else if(isComponent){

			// define global-shadow-child index if necessary
            if(!isBrowser && !leaf.componentInstanceID){
				leaf.componentInstanceID = `GSC${this.globalShadowComponentInstanceIndex++}`
			}

			// set leafs' visibility
			leaf.isVisible = true;
			if(leaf.subType === 'layout' && leaf.status && leaf.status === 'invisible'){
				leaf.isVisible = false;
			}

			if(!isInitializedShadowComponent) {

				if(!leaf.isBuilt) {
					// set parentRouteData within the layoutComponent's data
					if(!isBrowser && leaf.subType === 'layout'){
						leaf.originalComponentInstanceID = leaf.componentInstanceID // originalComponentInstanceID may be used by proxyCacheController.getScope() later.
						leaf.componentInstanceID += '_' + parentRouteID;
						if(parentRouteData){
							if(parentRouteData.model && utils.collectionSize(parentRouteData.model) > 0)        leaf.model = utils.merge(leaf.model || {}, parentRouteData.model);
							if(parentRouteData.actions && utils.collectionSize(parentRouteData.actions) > 0)    leaf.actions = utils.replace(parentRouteData.actions, leaf.actions || {});
						}
					}

					// define new index if necessary
					if (
						!parentPostponesChildren
						&&
						(
							(isBrowser && (!leaf.componentIndex || !isRootTree))
							||
							(isRootTree && !isShadowComponent && !leaf.componentIndex && (isBrowser || !wasShadowComponent))
						)
					){
						leaf.componentIndex = (isBrowser ? -1 : 1) * this.getNextIndex();
					}

					if (leaf.componentClass === undefined) {
						// set some base parameters
						leaf.component = componentList.normalizeComponentGroup(leaf.component);
						leaf.componentClass = componentList.buildKey(leaf.component);
					}

					if (typeof(leaf.children) === 'undefined') leaf.children = [];
				}

				if(!parentPostponesChildren && parentComponentIndex !== undefined) leaf.parentComponentIndex = parentComponentIndex;
			}

			// set parentComponentInstanceID whenever possible (e.g., used for shadow component locating - so it is not necessarily a problem if more than one component instance within the client have the same componentInstanceID)
			if(parentComponentInstanceID !== undefined) leaf.parentComponentInstanceID = parentComponentInstanceID;

			if(!leaf.isBuilt) {

				// load template, component and style if necessary (only used browser side)
				componentList.load(leaf.component);

				// set extension data
				var componentKey = componentList.buildKey(leaf.component);
				if (!isInitializedShadowComponent){
					// set extension data
					var extension = leaf.extends;
					if(!utils.isEmpty(componentList.components[componentKey])) extension = extension || componentList.components[componentKey]._extends;
					leaf.extends = componentList.normalizeComponentGroup(extension);

					if(leaf.config === null) 			leaf.config = {};
					if(leaf.model === null) 			leaf.model = {};
					if(leaf.actions === null) 			leaf.actions = {};
					if(leaf.formMapping === null) 		leaf.formMapping = {};
					if(leaf.validatorRuleSet === null) 	leaf.validatorRuleSet = {};

					// merge leaf on base component
					var baseComponent = componentList.components[componentKey] || {};
					leaf = utils.merge(baseComponent, leaf);

					if(baseComponent.forceScope) leaf.scope = baseComponent.forceScope;
				}

				// set default config flags if neccessary
				if(leaf.config){
					if(leaf.config.isContainerComponent == undefined) leaf.config.isContainerComponent = false;
				}

				// prepare base resourceData if necessary
				if(!isBrowser && leaf.config && leaf.config.resourceData){
					leaf.resourceData = utils.simpleCopy(leaf.config.resourceData);
					delete leaf.config.resourceData;
				}

				// set leafs' scope if necessary
				if(
					leaf &&
					!leaf.scope &&
					parentLeafInfo.scope && (
						!(leaf.type === 'component' && !!leaf.sectionComponentID) ||
						parentLeafInfo.isSectionComponent
					)
				){
					leaf.scope = parentLeafInfo.scope;
				}

				// prepare model data if necessary
				const localResourceLoaders = {}
				if(!buildAborted && !isBrowser && leaf.model){
					this.prepareLeafFields(leaf, storage, prepareModelData, wasShadowComponent, parentRoutePath, localResourceLoaders, false, true, !isShadowOrChildOfOne, false, resourceLoadersUsesOwnService, false, undefined, undefined, parentPostponesChildren);
				}

				if(!buildAborted && !parentPostponesChildren){
					// assign template function with extension template function as fallback
					leaf.template   = componentList.getTemplate(componentKey);
					// assign base component
					leaf            = new Component(leaf, storage.requestID, storage.sessionID, storage.app.serviceDomain, environment);

					// a leaf may decide if it should be built or not.
					// @see CONSTANTS.COMPONENT:BUILD_GRANTED for further details.
					if(utils.isFunction(leaf.isBuildGranted)){
						let buildGranted = leaf.isBuildGranted(storage)
						if(!buildGranted) 				buildGranted = CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.NO;
						else if(buildGranted === true) 	buildGranted = CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES;

						if(
							buildGranted !== CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES &&
							buildGranted !== CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES_CACHED
						){
							return buildGranted
						}

						if(buildGranted === CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES){
							leaf.config.isCacheable = false
						}
					}
				}

				// if a component decides to not be built it's resourceLoaders will not be integrated into to global list of resourceLoaders.
				utils.forEach(localResourceLoaders, resourceLoader => {
					resourceLoaders[utils.collectionSize(resourceLoaders)] = resourceLoader
				})

				// call onBuild handler if necessary
				if(!buildAborted && !parentPostponesChildren && typeof(leaf.onBuild) === 'function'){
					leaf.onBuild(storage);
				}

				// prepare refreshResourceAction if necessary
				// TODO: remove resourceRegisterKey without resourceConfig or resourceTemplate?!?!
				// TODO: parentPostponseChildren resourceRegisterKey combo is a workaround. i do not understand the purpose of resourceRegisterKey condition yet (again).
				// TODO: POI additionals without base action.source.load??
				if(
					(!buildAborted && !isBrowser && leaf.config)
					&&
					(
						(leaf.config.resourceConfig || (!parentPostponesChildren && leaf.config.resourceRegisterKey !== undefined) || leaf.config.resourceTemplate)
						||
						utils.isFunction(leaf.getAdditionalResourceByActionSources)
					)
				){
					if(leaf.config.resourceTemplate){
						leaf.config = utils.merge(utils.action.getResourceTemplate(leaf.config.resourceTemplate), leaf.config);
					}

					let additionalResourceActionSources = {}
					if(utils.isFunction(leaf.getAdditionalResourceByActionSources)){
						additionalResourceActionSources = leaf.getAdditionalResourceByActionSources(storage) || {}
					}

					// TODO: PRIVILEGE AND SCOPE?
					leaf.actions.refreshResources = utils.action.getResource(null, {
						refreshResourcesOnComponentRefresh: leaf.config.refreshResourcesOnComponentRefresh,
						preloadResources: (leaf.config.preloadConfig || {}).preloadResources,
						resourceID:	leaf.config.resourceID || undefined,
						source: {
							...additionalResourceActionSources,
							load: {
								resourceConfig:         		leaf.config.resourceConfig || undefined,
								headers:                		leaf.config.headers || undefined,
								httpMethod:             		leaf.config.httpMethod || undefined,
								resourceRegisterKey:    		leaf.config.resourceRegisterKey || undefined,
								resourceWriteOnly: 				leaf.config.resourceWriteOnly || undefined,
								loadWhenPrimaryKeyPresentOnly: 	leaf.config.loadWhenPrimaryKeyPresentOnly || undefined,
								grantCacheByETag: 				leaf.config.grantCacheByETag || undefined,
							}
						},
						statusControllerLoadingMessage: leaf.config.statusControllerLoadingMessage,
						statusControllerSavingMessage:  leaf.config.statusControllerSavingMessage
					});

					// NOTE: resourceFilters will be set after build and before resource-preloading to guarantee complete storage data (request-data, ...)
					// NOTE: this is the place used to check if the component grants preloading according to some preconditions. e.g., if some user has to be logged in to make sense of a resource.
					// register resourceLoader if necessary
					if(!parentPostponesChildren && leaf.config.preloadConfig && leaf.config.preloadConfig.preloadResources && leaf.preloadResourcesGranted(storage)){
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: 'resource-action',
							scope: leaf.scope,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								action: 				'refreshResources',
								preloadConfig: 			leaf.config.preloadConfig,
								writeConfigResourceUrl: true,
								resourceFilters: 		{}
							}
						};
					}

					delete leaf.config.resourceConfig;
					delete leaf.config.headers;
					delete leaf.config.httpMethod;
					delete leaf.config.resourceID;
					delete leaf.config.resourceRegisterKey;
					delete leaf.config.statusControllerLoadingMessage;
					delete leaf.config.statusControllerSavingMessage;
				}

				// prepare actions if necessary
				if(!isBrowser && !wasShadowComponent){
					// import actions from parent routes if necessary
					if(utils.collectionSize(parentRouteActions) > 0){
						leaf.actions = utils.replace(utils.simpleCopy(parentRouteActions), leaf.actions);
					}

					componentList.prepareActions(
						componentList.grabSecureRoutes(leaf, leaf.privilegeCode, leaf.scope || leaf.grabSecureRoutesScope),
						parentRoutePath
					);
				}

				// sanitize model fields if necessary (e.g., used for route pickers to sanitize its data)
				if(!buildAborted && !parentPostponesChildren && !isBrowser && leaf.model && prepareModelData && leaf.subType != 'form' && utils.isFunction(leaf.sanitizeModelFields)){
					// TODO: check if this function may be eliminated.
					leaf.sanitizeModelFields(storage);
				}

				// create lookup to be able to use parent-component-functions within sanitizeResources()
				if(!buildAborted && !parentPostponesChildren && isBrowser && !!leaf.componentIndex){
					if(this.lookup[leaf.componentIndex] !== undefined && this.lookup[leaf.componentIndex].componentIndex != leaf.componentIndex){
						// TODO: throw error
						console.error('componentIndex already in use' + leaf.componentIndex);
					}
					this.lookup[leaf.componentIndex] = leaf;

					// create environment dependent lookup
					if(leaf.config && leaf.config.environmentDependent){
						this.environmentDependentLookup[leaf.componentIndex] = leaf;
					}
				}

				// sanitize form if necessary
				if(!buildAborted && !parentPostponesChildren && utils.isFunction(leaf.sanitizeForm) && leaf.model){
					leaf.sanitizeForm(storage);
				}

				// sanitize resourceData if necessary
				if(!buildAborted && !parentPostponesChildren){
					var hasParentResourceDependency = resourceDependencyParent !== undefined;
					leaf.hasDataDealer = typeof(leaf.dataDealer) === 'function';

					if(
						utils.isFunction(leaf.sanitizeResources)
						&&
						(
							leaf.subType !== 'form'
							||
							(
								(
									// subFormAlias-Forms have to wait until their data is ready.
									// the fecServer will perform a resourceSanitation after resourcePreloading-Phase.
									// the fecClient may perform the resourceSanitation after a specific request or onDomReady if the resource have been prepared by the server already.
									!utils.isEmpty(leaf.config.subFormAlias)
									&&
									isBrowser
								)
								||
								!utils.isEmpty(leaf.resourceData)
								||
								!utils.isEmpty(leaf.model.dirtyFields)
							)
						)
					){
						if(isBrowser){
							// prevent resource sanitation on client when server has done resource sanitation during preLoad phase
							if(!leaf._resourceSanitationDoneByPreloading || !utils.isEmpty(leaf.config.subFormAlias)){
								if(hasParentResourceDependency){
									if(this.lookup[leaf.parentComponentIndex]){
										this.lookup[leaf.parentComponentIndex].registerResourceDependent(leaf.componentIndex);
									}
								}
								else if(!leaf.config.resourceRegisterKey || leaf._resourceRegisterSanitationDone){
									if(leaf.hasDataDealer){
										leaf._dataDealer(true);
										leaf.sanitizeResources(storage);
									}
									else if(!leaf.config.isInclusionShadow || !utils.isEmpty(leaf.resourceData)) {
										leaf.sanitizeResources(storage);
									}
								}
								else {
									leaf._reperformResourceSanitation = true;
								}
							}
						}
						else {
							leaf.sanitizeResources(storage);
						}
					}
					// invoke dataDealer to get all data into the right place which could not be delivered by a resource-request, the resource-registry or the default triggers.
					else if(isBrowser && isRootTree){
						if(leaf.hasDataDealer){
							leaf._dataDealer();
						}
					}
				}

				// define registry-properties for subForms if necessary
				if(!buildAborted && leaf.config && !!leaf.config.subFormAlias && !leaf.config.registerSecret){
					leaf.config.registerType = 'subForm';
					leaf.config.registerSecret = leaf.config.subFormAlias;
				}

				// register handlers if necessary
				if(!buildAborted && !parentPostponesChildren && isBrowser && !isShadowComponent && leaf.componentIndex && leaf.handlers){
					utils.forEach(leaf.handlers, function(handler){
						if(!utils.isEmpty(handler.name) && utils.isFunction(handler.handle)){
							if(self.handlers[handler.name] === undefined) self.handlers[handler.name] = [];
							self.handlers[handler.name].push(utils.merge(handler, {
								calleeComponentIndex: leaf.componentIndex
							}));
						}
					});
					delete leaf.handlers;
				}
			}
		}
		// is global shadowContainer
		else if(isGlobalShadowContainer){
			// NOTHING TO DO
		}

		return leaf;
	};

	/**
	 * this function prepares the resourceLoaders of all fields' within the given leaf.
	 *
	 * @param   leaf                        						object - leaf (component data)
	 * @param   storage                     						object - actual storage
	 * @param   prepareModelData            						boolean - this flag decides if the model has to be prepared (atom to flag transformation) or not.
	 * @param   wasShadowComponent           						boolean - was this leaf a shadowComponent or not
	 * @param   parentRoutePath             						string - path to parent route element
	 * @param   resourceLoaders             						object - actual resourceLoaders
	 * @param   storeLeafInstance           						boolean - should the preparation process store the leaf instances within the resourceLoaders or not
	 * @param   prepareFieldsIfPlacedInForeignService				boolean - should the actual leaf fields be processed as form (resources be loaded) in case of a foreign service
	 * @param   preloadResourcesByDefault							boolean - should the actual resource be preloaded if no preloadResources flag has been defined
	 * @param   refreshResourcesOnComponentRefreshByDefault			boolean - should the actual refreshResourcesOnComponentRefresh-flag be set to true if no refreshResourcesOnComponentRefresh-flag has been defined
	 * @param   [useOwnService=true]								boolean - should the own service be used to gather the resources or not
	 * @param   [treatPickerAsPicked=false]							boolean - isPicked-default value for pickers (especially used within componentTreeSearch)
	 * @param   [forceStandardFieldPreparation=false]				boolean - force field preparation like a web-site-use-case would do
	 * @param   overrulingProtocolActionFields						boolean - TODO: DOCS!
	 * @param   parentPostponesChildren            					boolean - optional - if this is set to true only necessary extractions would be performed on the actual leaf and its children. (e.g., shadow components or action definitions would be registered).
	 *                                            					this is useful if a component will never be rendered on the server but should be built in the fec-client. e.g., base_form_relationship children for event.registrationForm.
	 */
	ComponentTree.prototype.prepareLeafFields = function(leaf, storage, prepareModelData, wasShadowComponent, parentRoutePath, resourceLoaders, storeLeafInstance, prepareFieldsIfPlacedInForeignService, preloadResourcesByDefault, refreshResourcesOnComponentRefreshByDefault, useOwnService, treatPickerAsPicked, forceStandardFieldPreparation, overrulingProtocolActionFields, parentPostponesChildren){
		leaf.actions = leaf.actions || {}
		let dataIndex, mediaIDs, routeIDs
		let willBePreparedByAPI
		let actionPrefix, defaultResourceTemplate, surrogateDataType
		let refreshResourcesOnComponentRefresh, resourceTemplate
		let fieldRequestedService

		preloadResourcesByDefault = Boolean(preloadResourcesByDefault)
		if(useOwnService === undefined) useOwnService = true;
		else 							useOwnService = Boolean(useOwnService);
		refreshResourcesOnComponentRefreshByDefault = Boolean(refreshResourcesOnComponentRefreshByDefault)
		if(resourceLoaders === undefined) resourceLoaders = {};

		treatPickerAsPicked = Boolean(treatPickerAsPicked)
		forceStandardFieldPreparation = Boolean(forceStandardFieldPreparation)

		if(
			(
				(leaf.subType === 'form' && prepareFieldsIfPlacedInForeignService)
				||
				(leaf.subType !== 'form' && !prepareFieldsIfPlacedInForeignService)
			)
			&&
			!forceStandardFieldPreparation
		){
			if(utils.collectionSize((leaf.model || {}).fields) > 0){
				utils.forEachReverse(leaf.model.fields, function(field, fieldIndex){
					if(
						(
							(field.config || {}).privilegeCode &&
							!storage.user.hasAccessTo((field.config || {}).privilegeCode, leaf.scope || undefined)
						)
						||
						(
							leaf.config &&
							leaf.config.privilegeBase &&
							field.fieldCode &&
							!storage.user.hasAttributeAccessTo(leaf.scope || undefined, leaf.config.privilegeBase, 'read', field.fieldCode)
						)
					){
						leaf.model.fields.splice(fieldIndex, 1);
					}
				});

				let visibilityByFieldCode = {}
				if(overrulingProtocolActionFields !== undefined){
					visibilityByFieldCode = utils.getProtocolActionFieldVisibility(overrulingProtocolActionFields, leaf.model.fields, true)
				}

				utils.forEach(leaf.model.fields, function(field, fieldIndex){
					// prevent cms_templatesAtoms.config === null from initializing a fields model.config via file properly
					field.config = field.config || {}

					// prepare requestedService used within field resources
					fieldRequestedService = undefined
					if(field.config.fecRequestedService !== undefined){
						fieldRequestedService = field.config.fecRequestedService
					} else if(field.config.requestedService !== undefined){
						fieldRequestedService = field.config.requestedService
					} else if(useOwnService){
						fieldRequestedService = false
					}

					// hide special hidden fields via renderType=none in case of special show privilege
					if(
						(
							leaf.config &&
							leaf.config.privilegeBase &&
							field.fieldCode &&
							!storage.user.hasAttributeAccessTo(leaf.scope || undefined, leaf.config.privilegeBase, 'show', field.fieldCode)
						)
						||
						(
							// protocolActionChanges: since separatedFieldCodes would not work any longer if the changed fields only would be left within the field list,
							// renderType = none is way easier to manage without side effects.
							field.fieldCode &&
							overrulingProtocolActionFields !== undefined &&
							!visibilityByFieldCode[field.fieldCode]
						)
					){
						leaf.model.fields[fieldIndex].atom.renderType = 'none';
					}
					// respect force render-type config flag
					else if(field.config.forceRenderType){
						leaf.model.fields[fieldIndex].atom.renderType = field.config.forceRenderType;
					}
					// respect force data-type config flag
					if(field.config.forceDataType){
						leaf.model.fields[fieldIndex].atom.dataType = field.config.forceDataType;
					}

					// overrule field values based on protocolAction if necessary
					if(
						field.templateAtomID &&
						overrulingProtocolActionFields !== undefined &&
						(overrulingProtocolActionFields || {})[field.templateAtomID] !== undefined
					){
						const dataValueKey = utils.getDataValueKey((field.atom || {}).dataType)
						leaf.model.fields[fieldIndex][dataValueKey] = overrulingProtocolActionFields[field.templateAtomID][dataValueKey]
					}

					// prepare template-pickers' data
					if(field.atom.dataType === 'template-picker'){
						const templates = Object.values((((storage.app || {}).webService || {}).containerInfo || {}).templates || {})
						if(templates.length > 0){
							if(!leaf.model.fields[fieldIndex]['template-picker-data']) leaf.model.fields[fieldIndex]['template-picker-data'] = {};
							leaf.model.fields[fieldIndex]['template-picker-data'].options = templates.map(template => ({ name: template, value: template}))
						}
					}
					// prepare resource-pickers' data
					else if(field.atom.dataType === 'resource-picker'){
						if(!field.config) 					field.config = {};
						if(!field.config.resourceConfig) 	field.config.resourceConfig = {};

						var loadConfig = {}
						if (field.config.resourceTemplate) {
							loadConfig = utils.merge(utils.action.getResourceTemplate(field.config.resourceTemplate), {
								resourceConfig:         field.config.resourceConfig,
								headers:                field.config.headers,
								httpMethod:             field.config.httpMethod
							})
						} else {
							loadConfig = {
								resourceConfig:         field.config.resourceConfig,
								headers:                field.config.headers,
								httpMethod:             field.config.httpMethod
							}
						}

						if(fieldRequestedService !== undefined){
							loadConfig.resourceConfig.requestedService = fieldRequestedService
						}

						refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
						if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
							refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
						}
						leaf.actions['resourcePicker_' + field.fieldCode] = utils.action.getResource('resourcePicker', {
							refreshResourcesOnComponentRefresh,
							preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
							fieldIndex: fieldIndex,
							fieldCode: field.fieldCode,
							source: {
								load: loadConfig
							}
						});
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: 'resource-picker',
							scope: leaf.scope,
							leaf: storeLeafInstance ? leaf : false,
							group: field.templateAtomID || 0,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								fieldIndex:             fieldIndex,
								fieldCode: 				field.fieldCode,
								action: 				'resourcePicker_' + field.fieldCode,
								preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
								writeConfigResourceUrl: false
							}
						}
						if(leaf.model.fields[fieldIndex].config){
							delete leaf.model.fields[fieldIndex].config.resourceConfig
							delete leaf.model.fields[fieldIndex].config.resourceTemplate
						}
					}
					// prepare tag-pickers' data
					else if(field.atom.dataType === 'tag-picker'){
						var additionalResourceConfigs = {};
						// TODO: POIA: remove this resource def into resourceTemplateGenerator for tagPicker resourceTemplate
						if(field.config.categoryEntityType === 'routes'){
							additionalResourceConfigs.routes = {
								route: '/rawQuery',
								body: {
									query: `
										WITH RECURSIVE r AS (
											(SELECT rr."routeID", rr."parentRouteID" FROM cms_routes rr WHERE rr."routeID" = :routeID AND :routeID > 0)
											UNION
											(SELECT * FROM (SELECT r."parentRouteID" as "routeID", (SELECT rr."parentRouteID" FROM cms_routes rr WHERE rr."routeID" = r."parentRouteID") as "parentRouteID" FROM r WHERE r."parentRouteID" != 0) x WHERE "routeID" IS NOT NULL)
										) 
										SELECT "routeID", "parentRouteID" FROM r ORDER BY "parentRouteID" ASC, "routeID" ASC;
									`
								},
								resourceParams: {
									routeID: {
										type: 'int',
										default: 0
									}
								},
								dataStructure: {
									primaryKey: 'routeID',
									route: '/modules/cms/routes'
								}
							};
							additionalResourceConfigs.routeTags = {
								route: '/dataQuery',
								resourceQuery: {
									model: 'cms_entities_categories',
									where: {
										entityType: 'routes',
										entityID: ':routeID' // TODO: POIA: HOW?!?
									}
								},
								resourceParams: {
									routeID: {
										type: 'int',
										default: 0
									}
								},
								dataStructure: {
									primaryKey: 'categoryEntityID',
									route: '/modules/cms/entities_categories'
								}
							};

							if(fieldRequestedService !== undefined){
								additionalResourceConfigs.routes.requestedService = fieldRequestedService
								additionalResourceConfigs.routeTags.requestedService = fieldRequestedService
							}
						}

						refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
						if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
							refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
						}
						leaf.actions['tagPicker_' + field.fieldCode] = utils.action.getResource('tagPicker', {
							refreshResourcesOnComponentRefresh,
							preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
							fieldIndex: fieldIndex,
							fieldCode: field.fieldCode,
							source: {
								load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || 'tagPicker')), {
									headers:                field.config.headers || {},
									httpMethod:             field.config.httpMethod || {},
									resourceConfig:         {
										grantCacheByETag: 	true,
										cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
										requestedService: 	fieldRequestedService,
										additionalResourceConfigs: additionalResourceConfigs
									},
									resourceFilters: {
										tagScopeCode: 		field.config.tagScope || 'MISSING_TAG_SCOPE',
									},
								})
							}
						});
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: 'tag-picker',
							scope: leaf.scope,
							leaf: storeLeafInstance ? leaf : false,
							group: field.templateAtomID || 0,
							isPicked: treatPickerAsPicked,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								fieldIndex:             fieldIndex,
								fieldCode: 				field.fieldCode,
								action: 				'tagPicker_' + field.fieldCode,
								preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
								resourceFilters: {
									tagScopeCode: 		field.config.tagScope || 'MISSING_TAG_SCOPE',
								},
								writeConfigResourceUrl: false
							}
						};
						if(leaf.model.fields[fieldIndex].config){
							delete leaf.model.fields[fieldIndex].config.resourceConfig;
							delete leaf.model.fields[fieldIndex].config.resourceTemplate;

							// register additional attribute dependency of tagConnection if it is selectable and has not been configured manually.
							var tagConnectionFieldCode = `${field.fieldCode}_tagConnection`
							if(leaf.model.fields[fieldIndex].config.tagConnectionChoosable && (leaf.model.fields[fieldIndex].config.handleAdditionalAttributes || {})[tagConnectionFieldCode] === undefined){
								leaf.model.fields[fieldIndex].config.handleAdditionalAttributes = leaf.model.fields[fieldIndex].config.handleAdditionalAttributes || {}
								if(leaf.model.fields[fieldIndex].config.handleAdditionalAttributes[tagConnectionFieldCode] === undefined){
									leaf.model.fields[fieldIndex].config.handleAdditionalAttributes[tagConnectionFieldCode] = true;
								}
							}
							leaf.model.fields[fieldIndex].additionalAttributes = leaf.model.fields[fieldIndex].additionalAttributes || {}
						}
					}
					else if(field.atom.dataType === 'route-picker'){
						willBePreparedByAPI = field.hasExternalDataDependency || false;
						if(!willBePreparedByAPI){
							refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
							if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
								refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
							}
							leaf.actions['routePicker_' + field.fieldCode] = utils.action.getResource('routePicker', {
								refreshResourcesOnComponentRefresh,
								preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
								fieldIndex: fieldIndex,
								fieldCode: field.fieldCode,
								source: {
									load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || 'routePickerSimple')), {
										resourceConfig: {
											grantCacheByETag: 	true,
											cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
											requestedService: 	fieldRequestedService,
										},
										headers:                field.config.headers,
										httpMethod:             field.config.httpMethod
									})
								}
							});
							resourceLoaders[utils.collectionSize(resourceLoaders)] = {
								type: 'route-picker',
								scope: leaf.scope,
								leaf: storeLeafInstance ? leaf : false,
								group: field.templateAtomID || 0,
								isPicked: treatPickerAsPicked,
								target: {
									componentInstanceID:    leaf.componentInstanceID,
									fieldIndex:             fieldIndex,
									fieldCode: 				field.fieldCode,
									action: 				'routePicker_' + field.fieldCode,
									preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
									writeConfigResourceUrl: false
								}
							};
							if(leaf.model.fields[fieldIndex].config){
								delete leaf.model.fields[fieldIndex].config.resourceConfig;
								delete leaf.model.fields[fieldIndex].config.resourceTemplate;
							}
						}
					}
					else if(field.atom.dataType === 'route-picker-full'){

						routeIDs = [];
						for(dataIndex in field.dataJSON || []){
							if(field.dataJSON[dataIndex].routeID){
								routeIDs.push(field.dataJSON[dataIndex].routeID);
							}
						}

						refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
						if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
							refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
						}
						leaf.actions['routePickerFull_' + field.fieldCode] = utils.action.getResource('routePickerFull', {
							refreshResourcesOnComponentRefresh,
							preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
							fieldIndex: fieldIndex,
							fieldCode: field.fieldCode,
							source: {
								load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || 'routePickerFullSimple')), {
									resourceConfig: {
										grantCacheByETag: 	true,
										cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
										requestedService: 	fieldRequestedService,
									},
									headers:                field.config.headers || resourceTemplate.headers,
									httpMethod:             field.config.httpMethod || resourceTemplate.httpMethod,
								})
							}
						});
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: 'route-picker-full',
							scope: leaf.scope,
							leaf: storeLeafInstance ? leaf : false,
							group: field.atom.dataType || field.templateAtomID || 0,
							isPicked: treatPickerAsPicked,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								fieldIndex:             fieldIndex,
								fieldCode: 				field.fieldCode,
								action: 				'routePickerFull_' + field.fieldCode,
								preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
								resourceFilters: {
									...(field.config.fieldResourceFilters || {}),
									listOfRouteIDs: routeIDs
								},
								writeConfigResourceUrl: false
							}
						};
						if(leaf.model.fields[fieldIndex].config){
							delete leaf.model.fields[fieldIndex].config.resourceConfig;
							delete leaf.model.fields[fieldIndex].config.resourceTemplate;
						}
					}
					else if(field.atom.dataType === 'route-component-picker'){
						var willBePreparedByAPI = field.hasExternalDataDependency || false;
						if(!willBePreparedByAPI){
							refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
							if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
								refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
							}
							leaf.actions['routeComponentPicker_' + field.fieldCode] = utils.action.getResource('routeComponentPicker', {
								refreshResourcesOnComponentRefresh,
								preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
								fieldIndex: fieldIndex,
								fieldCode: field.fieldCode,
								source: {
									load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || 'routeComponentPickerSimple')), {
										resourceConfig: {
											grantCacheByETag: 	true,
											cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
											requestedService: 	fieldRequestedService,
										},
										headers:                field.config.headers,
										httpMethod:             field.config.httpMethod
									})
								}
							});
							resourceLoaders[utils.collectionSize(resourceLoaders)] = {
								type: 'route-component-picker',
								scope: leaf.scope,
								leaf: storeLeafInstance ? leaf : false,
								group: field.templateAtomID || 0,
								isPicked: treatPickerAsPicked,
								target: {
									componentInstanceID:    leaf.componentInstanceID,
									fieldIndex:             fieldIndex,
									fieldCode: 				field.fieldCode,
									action: 				'routeComponentPicker_' + field.fieldCode,
									preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
									writeConfigResourceUrl: false
								}
							};
							if(leaf.model.fields[fieldIndex].config){
								delete leaf.model.fields[fieldIndex].config.resourceConfig;
								delete leaf.model.fields[fieldIndex].config.resourceTemplate;
							}
						}
					}
					else if(field.atom.dataType === 'category-picker'){
						willBePreparedByAPI = field.hasExternalDataDependency || false;
						if(!willBePreparedByAPI){
							refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
							if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
								refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
							}
							leaf.actions['categoryPicker_' + field.fieldCode] = utils.action.getResource('categoryPicker', {
								refreshResourcesOnComponentRefresh,
								preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
								fieldIndex: fieldIndex,
								fieldCode: field.fieldCode,
								source: {
									load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || 'categoryPickerSimple')), {
										resourceConfig: {
											grantCacheByETag: 	true,
											cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
											requestedService: 	fieldRequestedService,
										},
										headers:                field.config.headers,
										httpMethod:             field.config.httpMethod,
									})
								}
							});
							resourceLoaders[utils.collectionSize(resourceLoaders)] = {
								type: 'category-picker',
								scope: leaf.scope,
								leaf: storeLeafInstance ? leaf : false,
								group: field.templateAtomID || 0,
								isPicked: treatPickerAsPicked,
								target: {
									componentInstanceID:    leaf.componentInstanceID,
									fieldIndex:             fieldIndex,
									fieldCode: 				field.fieldCode,
									action: 				'categoryPicker_' + field.fieldCode,
									preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
									writeConfigResourceUrl: false
								}
							};
							if(leaf.model.fields[fieldIndex].config){
								delete leaf.model.fields[fieldIndex].config.resourceConfig;
								delete leaf.model.fields[fieldIndex].config.resourceTemplate;
							}
						}
					}
					else if(field.atom.dataType === 'media-image'){
						if(!wasShadowComponent){
							if(!field.config.secureRoute){
								field.config.secureRoute = '/~/upload/preparedImage'
							}
							componentList.grabSecureRoutes(leaf.model.fields[fieldIndex], leaf.privilegeCode, leaf.scope || leaf.grabSecureRoutesScope)
						}

						mediaIDs = [];
						for(dataIndex in field.dataJSON || []){
							if(field.dataJSON[dataIndex].mediaID){
								mediaIDs.push(field.dataJSON[dataIndex].mediaID);
							}
						}

						actionPrefix = 'mediaImage';
						defaultResourceTemplate = 'getCategorizedMediaFull';

						// preload tags and additional data of the original media
						leaf.actions[actionPrefix + '_' + field.fieldCode] = utils.action.getResource(actionPrefix, {
							refreshResourcesOnComponentRefresh: field.config.refreshResourcesOnComponentRefresh === undefined ? refreshResourcesOnComponentRefreshByDefault : field.config.refreshResourcesOnComponentRefresh,
							preloadResources: (field.config.preloadConfig || { preloadResources: true }).preloadResources || false,
							fieldIndex: fieldIndex,
							fieldCode: field.fieldCode,
							source: {
								load: utils.merge(utils.action.getResourceTemplate(field.config.resourceTemplate || defaultResourceTemplate), {
									resourceConfig: {
										requestedService: fieldRequestedService,
									}
								})
							}
						});
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: field.atom.dataType,
							scope: leaf.scope,
							leaf: storeLeafInstance ? leaf : false,
							group: field.atom.dataType || leaf.componentInstanceID || 0,
							isPicked: false,
							requestedService: fieldRequestedService,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								fieldIndex: 			fieldIndex,
								fieldCode: 				field.fieldCode,
								action: 				actionPrefix + '_' + field.fieldCode,
								preloadConfig: 			field.config.preloadConfig || { preloadResources: true },
								resourceFilters: {
									listOfMediaIDs: mediaIDs
								},
								writeConfigResourceUrl: false
							}
						};
						if(leaf.model.fields[fieldIndex].config){
							delete leaf.model.fields[fieldIndex].config.resourceConfig;
							delete leaf.model.fields[fieldIndex].config.resourceTemplate;
						}
					}
					else if(field.atom.dataType === 'media-file'){
						if(!wasShadowComponent){
							if(!field.config.secureRoute){
								field.config.secureRoute = '/~/upload/preparedFile'
							}
							componentList.grabSecureRoutes(leaf.model.fields[fieldIndex], leaf.privilegeCode, leaf.scope || leaf.grabSecureRoutesScope);
						}

						mediaIDs = [];
						for(dataIndex in field.dataJSON || []){
							if(field.dataJSON[dataIndex].mediaID){
								mediaIDs.push(field.dataJSON[dataIndex].mediaID);
							}
						}

						actionPrefix = 'mediaFile';
						defaultResourceTemplate = 'getCategorizedFilesFull';

						// preload tags and additional data of the original media
						leaf.actions[actionPrefix + '_' + field.fieldCode] = utils.action.getResource(actionPrefix, {
							refreshResourcesOnComponentRefresh: field.config.refreshResourcesOnComponentRefresh === undefined ? refreshResourcesOnComponentRefreshByDefault : field.config.refreshResourcesOnComponentRefresh,
							preloadResources: (field.config.preloadConfig || { preloadResources: true }).preloadResources || false,
							fieldIndex: fieldIndex,
							fieldCode: field.fieldCode,
							source: {
								load: utils.merge(utils.action.getResourceTemplate(field.config.resourceTemplate || defaultResourceTemplate), {
									resourceConfig: {
										requestedService: fieldRequestedService,
									}
								})
							}
						});
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: field.atom.dataType,
							scope: leaf.scope,
							leaf: storeLeafInstance ? leaf : false,
							group: field.atom.dataType || leaf.componentInstanceID || 0,
							isPicked: false,
							requestedService: fieldRequestedService,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								fieldIndex: 			fieldIndex,
								fieldCode: 				field.fieldCode,
								action: 				actionPrefix + '_' + field.fieldCode,
								preloadConfig: 			field.config.preloadConfig || { preloadResources: true },
								resourceFilters: {
									listOfMediaIDs: mediaIDs
								},
								writeConfigResourceUrl: false
							}
						};
						if(leaf.model.fields[fieldIndex].config){
							delete leaf.model.fields[fieldIndex].config.resourceConfig;
							delete leaf.model.fields[fieldIndex].config.resourceTemplate;
						}
					}
				});
			}
		}
		else if(prepareModelData) {
			if(utils.collectionSize((leaf.model || {}).fields) > 0){
				utils.forEachReverse(leaf.model.fields, function (field, fieldIndex) {
					if((field.config || {}).privilegeCode && !storage.user.hasAccessTo(field.config.privilegeCode, leaf.scope || undefined)){
						leaf.model.fields.splice(fieldIndex, 1);
					}
				})

				// NOTE: copy leaf.model.fields for the case that one field's fieldCode equals "fields"
				utils.forEach(leaf.model.fields, function (field, fieldIndex) {
					// prevent cms_templatesAtoms.config === null from initializing a fields model.config via file properly
					field.config = field.config || {}

					// prepare requestedService used within field resources
					fieldRequestedService = undefined
					if(field.config.fecRequestedService !== undefined){
						fieldRequestedService = field.config.fecRequestedService
					} else if(field.config.requestedService !== undefined){
						fieldRequestedService = field.config.requestedService
					} else if(useOwnService){
						fieldRequestedService = false
					}

					// respect force render- and / or data-type config flags
					if(field.config.forceRenderType){
						leaf.model.fields[fieldIndex].atom.renderType = field.config.forceRenderType;
					}
					if(field.config.forceDataType){
						leaf.model.fields[fieldIndex].atom.dataType = field.config.forceDataType;
					}

					if(field.atom.dataType === 'route-picker' || field.atom.dataType === 'category-picker' || field.atom.dataType === 'route-component-picker'){
						if(field.atom.dataType === 'route-picker'){
							actionPrefix = 'routePicker';
							defaultResourceTemplate = 'routePickerSimple';
						} else if(field.atom.dataType === 'category-picker'){
							actionPrefix = 'categoryPicker';
							defaultResourceTemplate = 'categoryPickerSimple';
						} else if(field.atom.dataType === 'route-component-picker'){
							actionPrefix = 'routeComponentPicker';
							defaultResourceTemplate = 'routeComponentPickerSimple';
						}

						willBePreparedByAPI = field.hasExternalDataDependency || false;
						if(willBePreparedByAPI) {
							leaf.model[field.fieldCode] = {
								data: 		field.dataJSON,
								options: 	field[field.atom.dataType + '-data']
							};
						} else {
							leaf.model[field.fieldCode] = {
								data: field.dataJSON
							};

							refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
							if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
								refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
							}
							// TODO: double grantCacheByEtag is not really nice but necessary at the moment!
							leaf.actions[actionPrefix + '_' + field.fieldCode] = utils.action.getResource(actionPrefix, {
								refreshResourcesOnComponentRefresh,
								preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
								fieldIndex: fieldIndex,
								fieldCode: field.fieldCode,
								source: {
									load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || defaultResourceTemplate)), {
										resourceConfig: {
											grantCacheByETag: 	true,
											cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
											requestedService: 	fieldRequestedService,
											sanitizerID: 	  	(field.config.sanitizerID ? field.config.sanitizerID : field.atom.dataType)
										},
										headers:                field.config.headers,
										httpMethod:             field.config.httpMethod,
									})
								}
							});
							resourceLoaders[utils.collectionSize(resourceLoaders)] = {
								type: field.atom.dataType,
								scope: leaf.scope,
								leaf: storeLeafInstance ? leaf : false,
								group: field.templateAtomID || 0,
								isPicked: true,
								target: {
									componentInstanceID:    leaf.componentInstanceID,
									fieldIndex: 			fieldIndex,
									fieldCode: 				field.fieldCode,
									action: 				actionPrefix + '_' + field.fieldCode,
									preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
									writeConfigResourceUrl: false
								}
							};
							if(leaf.model.fields[fieldIndex].config){
								delete leaf.model.fields[fieldIndex].config.resourceConfig;
								delete leaf.model.fields[fieldIndex].config.resourceTemplate;
							}
						}
					}
					else if(field.atom.dataType === 'resource-picker'){
						if(!(field.config.resourceConfig || {}).sanitizerID && (field.config.resourceConfig || {}).sanitizerID !== false){
							if(!leaf.model.fields[fieldIndex].config) 					leaf.model.fields[fieldIndex].config = {};
							if(!leaf.model.fields[fieldIndex].config.resourceConfig) 	leaf.model.fields[fieldIndex].config.resourceConfig = {};
							leaf.model.fields[fieldIndex].config.resourceConfig.sanitizerID = 'statusPrivilegePeriod';
						}

						leaf.model[field.fieldCode] = {
							data: field.dataJSON
						};

						// NOTE: in some rare cases it is necessary to load resources of a resource-picker to use the selected data within the service it was made for.
						leaf.model.fields[fieldIndex].config = componentList.grabResource(field.config, parentRoutePath, leaf.privilegeCode, leaf.scope);
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: 'resource-picker',
							scope: leaf.scope,
							leaf: storeLeafInstance ? leaf : false,
							group: field.templateAtomID || 0,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								fieldIndex:             fieldIndex
							}
						};
					}
					else if(field.atom.dataType === 'route-picker-full'){
						leaf.model[field.fieldCode] = field.dataJSON;

						if (field.dataJSON && utils.collectionSize(field.dataJSON) > 0) {
							routeIDs = [];
							for(dataIndex in field.dataJSON || []){
								if(field.dataJSON[dataIndex].routeID){
									routeIDs.push(field.dataJSON[dataIndex].routeID);
								}
							}

							if(routeIDs.length > 0){

								actionPrefix = 'routePickerFull';
								defaultResourceTemplate = 'routePickerFullSimple';

								// preload tags and additional data of the original route
								leaf.actions[actionPrefix + '_' + field.fieldCode] = utils.action.getResource(actionPrefix, {
									refreshResourcesOnComponentRefresh: false,
									preloadResources: (field.config.preloadConfig || { preloadResources: true }).preloadResources || false,
									fieldIndex: fieldIndex,
									fieldCode: field.fieldCode,
									source: {
										load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || defaultResourceTemplate)), {
											resourceConfig: {
												cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
												requestedService: 	fieldRequestedService,
											}
										})
									}
								});
								resourceLoaders[utils.collectionSize(resourceLoaders)] = {
									type: field.atom.dataType,
									scope: leaf.scope,
									leaf: storeLeafInstance ? leaf : false,
									group: field.atom.dataType || leaf.componentInstanceID || 0,
									isPicked: true,
									target: {
										componentInstanceID:    leaf.componentInstanceID,
										fieldIndex: 			fieldIndex,
										fieldCode: 				field.fieldCode,
										action: 				actionPrefix + '_' + field.fieldCode,
										preloadConfig: 			field.config.preloadConfig || { preloadResources: true },
										resourceFilters: {
											...(field.config.fieldResourceFilters || {}),
											listOfRouteIDs: routeIDs
										},
										writeConfigResourceUrl: false
									}
								};
								if(leaf.model.fields[fieldIndex].config){
									delete leaf.model.fields[fieldIndex].config.resourceConfig;
									delete leaf.model.fields[fieldIndex].config.resourceTemplate;
								}
							}
						}

						// copy special model element to provide field config short access (e.g., used within media-template-files)
						leaf.model['_' + field.fieldCode] = {
							config: leaf.model.fields[fieldIndex].config || {}
						};
					}
					else if(field.atom.dataType === 'tag-picker'){
						leaf.model[field.fieldCode] = {
							data: field.dataJSON
						};

						var additionalResourceConfigs = {};
						if(field.config.categoryEntityType === 'routes'){
							additionalResourceConfigs.routes = {
								route: '/rawQuery',
								body: {
									query: `
										WITH RECURSIVE r AS (
											(SELECT rr."routeID", rr."parentRouteID" FROM cms_routes rr WHERE rr."routeID" = :routeID AND :routeID > 0)
											UNION
											(SELECT * FROM (SELECT r."parentRouteID" as "routeID", (SELECT rr."parentRouteID" FROM cms_routes rr WHERE rr."routeID" = r."parentRouteID") as "parentRouteID" FROM r WHERE r."parentRouteID" != 0) x WHERE "routeID" IS NOT NULL)
										) 
										SELECT "routeID", "parentRouteID" FROM r ORDER BY "parentRouteID" ASC, "routeID" ASC;
									`
								},
								resourceParams: {
									routeID: {
										type: 'int',
										default: 0
									}
								},
								dataStructure: {
									primaryKey: 'routeID',
									route: '/modules/cms/routes'
								}
							};
							additionalResourceConfigs.routeTags = {
								route: '/dataQuery',
								resourceQuery: {
									model: 'cms_entities_categories',
									where: {
										entityType: 'routes',
										entityID: ':routeID'
									}
								},
								resourceParams: {
									routeID: {
										type: 'int',
										default: 0
									}
								},
								dataStructure: {
									primaryKey: 'categoryEntityID',
									route: '/modules/cms/entities_categories'
								}
							};

							if(fieldRequestedService !== undefined){
								additionalResourceConfigs.routes.requestedService = fieldRequestedService
								additionalResourceConfigs.routeTags.requestedService = fieldRequestedService
							}
						}

						refreshResourcesOnComponentRefresh = refreshResourcesOnComponentRefreshByDefault
						if(field.config.refreshResourcesOnComponentRefresh !== undefined) {
							refreshResourcesOnComponentRefresh = field.config.refreshResourcesOnComponentRefresh
						}
						leaf.actions['tagPicker_' + field.fieldCode] = utils.action.getResource('tagPicker', {
							refreshResourcesOnComponentRefresh,
							preloadResources: (field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh }).preloadResources,
							fieldIndex: fieldIndex,
							fieldCode: field.fieldCode,
							source: {
								load: utils.merge((resourceTemplate = utils.action.getResourceTemplate(field.config.resourceTemplate || 'tagPicker')), {
									headers:                field.config.headers || {},
									httpMethod:             field.config.httpMethod || {},
									resourceConfig:         {
										grantCacheByETag: 	true,
										cacheScope: 		field.config.cacheScope !== undefined ? field.config.cacheScope : ((resourceTemplate || {}).resourceConfig || {}).cacheScope,
										requestedService: 	fieldRequestedService,
										additionalResourceConfigs: additionalResourceConfigs
									},
									resourceFilters: {
										tagScopeCode: 		field.config.tagScope || 'MISSING_TAG_SCOPE',
									},
								})
							}
						});
						resourceLoaders[utils.collectionSize(resourceLoaders)] = {
							type: 'tag-picker',
							scope: leaf.scope,
							leaf: storeLeafInstance ? leaf : false,
							group: field.templateAtomID || 0,
							isPicked: true,
							target: {
								componentInstanceID:    leaf.componentInstanceID,
								fieldIndex:             fieldIndex,
								fieldCode: 				field.fieldCode,
								action: 				'tagPicker_' + field.fieldCode,
								preloadConfig: 			field.config.preloadConfig || { preloadResources: preloadResourcesByDefault || !refreshResourcesOnComponentRefresh },
								resourceFilters: {
									tagScopeCode: 		field.config.tagScope || 'MISSING_TAG_SCOPE',
								},
								writeConfigResourceUrl: false
							}
						};
						if(leaf.model.fields[fieldIndex].config){
							delete leaf.model.fields[fieldIndex].config.resourceConfig;
							delete leaf.model.fields[fieldIndex].config.resourceTemplate;

							// register additional attribute dependency of tagConnection if it is selectable and has not been configured manually.
							var tagConnectionFieldCode = `${field.fieldCode}_tagConnection`
							if(leaf.model.fields[fieldIndex].config.tagConnectionChoosable && (leaf.model.fields[fieldIndex].config.handleAdditionalAttributes || {})[tagConnectionFieldCode] === undefined){
								leaf.model.fields[fieldIndex].config.handleAdditionalAttributes = leaf.model.fields[fieldIndex].config.handleAdditionalAttributes || {}
								if(leaf.model.fields[fieldIndex].config.handleAdditionalAttributes[tagConnectionFieldCode] === undefined){
									leaf.model.fields[fieldIndex].config.handleAdditionalAttributes[tagConnectionFieldCode] = true;
								}
							}
							leaf.model.fields[fieldIndex].additionalAttributes = leaf.model.fields[fieldIndex].additionalAttributes || {}
						}

					}
					else if(field.atom.dataType === 'media-image'){
						leaf.model[field.fieldCode] = field.dataJSON;

						if (field.dataJSON && utils.collectionSize(field.dataJSON) > 0) {
							mediaIDs = [];
							for(dataIndex in field.dataJSON || []){
								if(field.dataJSON[dataIndex].mediaID){
									mediaIDs.push(field.dataJSON[dataIndex].mediaID);
								}
							}

							if(mediaIDs.length > 0){

								actionPrefix = 'mediaImage';
								defaultResourceTemplate = 'getCategorizedMediaFull';

								// preload tags and additional data of the original media
								leaf.actions[actionPrefix + '_' + field.fieldCode] = utils.action.getResource(actionPrefix, {
									refreshResourcesOnComponentRefresh: false,
									preloadResources: (field.config.preloadConfig || { preloadResources: true }).preloadResources || false,
									fieldIndex: fieldIndex,
									fieldCode: field.fieldCode,
									source: {
										load: utils.merge(utils.action.getResourceTemplate(field.config.resourceTemplate || defaultResourceTemplate), {
											resourceConfig: {
												requestedService: fieldRequestedService,
											}
										})
									}
								});
								resourceLoaders[utils.collectionSize(resourceLoaders)] = {
									type: field.atom.dataType,
									scope: leaf.scope,
									leaf: storeLeafInstance ? leaf : false,
									group: field.atom.dataType || leaf.componentInstanceID || 0,
									isPicked: true,
									requestedService: fieldRequestedService,
									target: {
										componentInstanceID:    leaf.componentInstanceID,
										fieldIndex: 			fieldIndex,
										fieldCode: 				field.fieldCode,
										action: 				actionPrefix + '_' + field.fieldCode,
										preloadConfig: 			field.config.preloadConfig || { preloadResources: true },
										resourceFilters: {
											listOfMediaIDs: mediaIDs
										},
										writeConfigResourceUrl: false
									}
								};
								if(leaf.model.fields[fieldIndex].config){
									delete leaf.model.fields[fieldIndex].config.resourceConfig;
									delete leaf.model.fields[fieldIndex].config.resourceTemplate;
								}
							}
						}

						// copy special model element to provide field config short access (e.g., used within media-template-files)
						leaf.model['_' + field.fieldCode] = {
							config: leaf.model.fields[fieldIndex].config || {}
						};
					}
					else if(field.atom.dataType === 'media-file'){
						leaf.model[field.fieldCode] = field.dataJSON;

						if (field.dataJSON && utils.collectionSize(field.dataJSON) > 0) {
							mediaIDs = [];
							for(dataIndex in field.dataJSON || []){
								if(field.dataJSON[dataIndex].mediaID){
									mediaIDs.push(field.dataJSON[dataIndex].mediaID);
								}
							}

							if(mediaIDs.length > 0){

								actionPrefix = 'mediaFile';
								defaultResourceTemplate = 'getCategorizedFilesFull';

								// preload tags and additional data of the original media
								leaf.actions[actionPrefix + '_' + field.fieldCode] = utils.action.getResource(actionPrefix, {
									refreshResourcesOnComponentRefresh: false,
									preloadResources: (field.config.preloadConfig || { preloadResources: true }).preloadResources || false,
									fieldIndex: fieldIndex,
									fieldCode: field.fieldCode,
									source: {
										load: utils.merge(utils.action.getResourceTemplate(field.config.resourceTemplate || defaultResourceTemplate), {
											resourceConfig: {
												requestedService: fieldRequestedService,
											}
										})
									}
								});
								resourceLoaders[utils.collectionSize(resourceLoaders)] = {
									type: field.atom.dataType,
									scope: leaf.scope,
									leaf: storeLeafInstance ? leaf : false,
									group: field.atom.dataType || leaf.componentInstanceID || 0,
									isPicked: true,
									requestedService: fieldRequestedService,
									target: {
										componentInstanceID:    leaf.componentInstanceID,
										fieldIndex: 			fieldIndex,
										fieldCode: 				field.fieldCode,
										action: 				actionPrefix + '_' + field.fieldCode,
										preloadConfig: 			field.config.preloadConfig || { preloadResources: true },
										resourceFilters: {
											listOfMediaIDs: mediaIDs
										},
										writeConfigResourceUrl: false
									}
								};
								if(leaf.model.fields[fieldIndex].config){
									delete leaf.model.fields[fieldIndex].config.resourceConfig;
									delete leaf.model.fields[fieldIndex].config.resourceTemplate;
								}
							}
						}

						// copy special model element to provide field config short access (e.g., used within media-template-files)
						leaf.model['_' + field.fieldCode] = {
							config: leaf.model.fields[fieldIndex].config || {}
						};
					}
					else if(field.atom.dataType === 'html'){

						if(typeof(field.dataTEXT) === 'string' && field.dataTEXT != ''){
							// replace file urls
							var regex = new RegExp(/cmsfile:\/\/([0-9]+)\$/, 'g');
							field.dataTEXT = field.dataTEXT.replace(regex, function(match, elementID){
								var result = '#';
								if(elementID && ((storage.app.files || {}).data || {})[elementID]) {
									result = storage.app.files.data[String(elementID)].url;
								}
								return result;
							});

							// prepare routes found in text
							regex = new RegExp(/cmspage:\/\/([0-9]+)\$/, 'g');
							routeIDs = [];
							var match;
							while ((match = regex.exec(field.dataTEXT)) !== null) {
								if(match[1] == (match[1] * 1)){
									routeIDs.push(match[1] * 1);
								}
							}

							if(routeIDs.length > 0){
								actionPrefix = 'routePickerFull';
								defaultResourceTemplate = 'routePickerFullSimple';
								surrogateDataType = 'route-picker-full';

								// preload tags and additional data of the original route
								leaf.actions[actionPrefix + '_' + field.fieldCode] = utils.action.getResource(actionPrefix, {
									refreshResourcesOnComponentRefresh: false,
									preloadResources: (field.config.preloadConfig || { preloadResources: true }).preloadResources || false,
									fieldIndex: fieldIndex,
									fieldCode: field.fieldCode,
									source: {
										load: utils.merge(utils.action.getResourceTemplate(field.config.resourceTemplate || defaultResourceTemplate), {
											resourceConfig: {
												requestedService: fieldRequestedService,
											}
										})
									}
								});
								resourceLoaders[utils.collectionSize(resourceLoaders)] = {
									type: surrogateDataType,
									scope: leaf.scope,
									leaf: storeLeafInstance ? leaf : false,
									group: surrogateDataType,
									isPicked: true,
									isTextReplacement: true,
									target: {
										componentInstanceID:    leaf.componentInstanceID,
										fieldIndex: 			fieldIndex,
										fieldCode: 				field.fieldCode,
										action: 				actionPrefix + '_' + field.fieldCode,
										preloadConfig: 			{ preloadResources: true },
										resourceFilters: {
											listOfRouteIDs: routeIDs
										},
										writeConfigResourceUrl: false
									}
								};
							}
						}

						leaf.model[field.fieldCode] = field.dataTEXT;
					}
					else {
						// copy fields from model.fields to model if necessary
						leaf.model[field.fieldCode] = field[utils.getDataValueKey(field.atom.dataType)];
					}
				});
			}
		}
		else if(utils.collectionSize((leaf.model || {}).fields) > 0){
			utils.forEachReverse(leaf.model.fields, function (field, fieldIndex) {
				if((field.config || {}).privilegeCode && !storage.user.hasAccessTo((field.config || {}).privilegeCode, leaf.scope || undefined)){
					leaf.model.fields.splice(fieldIndex, 1);
				}
			})
			utils.forEach(leaf.model.fields, function (field, fieldIndex) {
				// prevent cms_templatesAtoms.config === null from initializing a fields model.config via file properly
				field.config = field.config || {}

				// respect force render- and / or data-type config flags
				if(field.config.forceRenderType){
					leaf.model.fields[fieldIndex].atom.renderType = field.config.forceRenderType;
				}
				if(field.config.forceDataType){
					leaf.model.fields[fieldIndex].atom.dataType = field.config.forceDataType;
				}

				// this is needed when a resource-picker is located within a form which has to be instantiated within a cms-service
				// and the resource cannot be loaded because the user within the super-cms or cms may not have privileges on the db-defined resources
				// of this picker.
				if(field.atom.dataType === 'resource-picker'){
					// the resource definition has to be grabed either way to prevent security issues (resource query definitions must never leave the server)
					leaf.model.fields[fieldIndex].config = componentList.grabResource(field.config, parentRoutePath, leaf.privilegeCode, leaf.scope);
				} else if(field.atom.dataType === 'media-image'){
					// TODO: what is this case?
					// console.log('media prepare A');
				}
			});
		}
	}

	/**
	 * this function returns the deepest path within the given componentTree.
	 * NOTE: the given tree has not been built.
	 *
	 * @param   tree
	 * @return  string - found path or empty string in an error case.
	 */
	ComponentTree.prototype.extractPath = function(tree){
		var path = '';
		if(tree.path) path = tree.path;
		if(tree.children){
			var childPath;
			var self = this;
			utils.forEach(tree.children, function(child){
				childPath = self.extractPath(child);
			});
			if(childPath) path = childPath;
		}
		return path;
	};

	/**
	 * this function returns the cached raw tree identified by the given routeID or route.
	 *
	 * @param routeID       		int - routeID
	 * @param route         		string - route
	 * @param routeComponentIDs     array - routeComponentIDs
	 * @return  cached raw tree or false otherwise.
	 */
	ComponentTree.prototype.getRawTree = function(routeID, route, routeComponentIDs){
		if(appConfig.cache.reuseCachedRawTrees && utils.jsonpack){
			if(route !== undefined){
				if(this.rawTrees[route]){
					return utils.jsonpack.unpack(this.rawTrees[route]);
				}
				const corePath = (this.routeIdentificationMapping[route] || {}).corePath
				if(this.rawTrees[corePath || '~~~NON_EXISTING_ROUTE~~~']){
					return utils.jsonpack.unpack(this.rawTrees[corePath]);
				}
			}
			if(routeID !== undefined && this.rawTrees[routeID]) return utils.jsonpack.unpack(this.rawTrees[routeID]);
			if(utils.collectionSize(routeComponentIDs) > 0){
				var routeComponentIDsKey = `_routeComponentIDs_${routeComponentIDs.join('_')}`;
				if(this.rawTrees[routeComponentIDsKey]) return utils.jsonpack.unpack(this.rawTrees[routeComponentIDsKey]);
			}
		}

		return false;
	};

	/**
	 * this function is used to cache the raw tree according to the given parameters.
	 * NOTE: if the config is not set appropriate the cache won't be written.
	 * NOTE: either the routeID or the route or both has to be set - otherwise no cache will be written.
	 *
	 * @param storage       						object - actual storage
	 * @param routeID       						int - routeID
	 * @param route         						string - route
	 * @param routeComponentIDs     				array - routeComponentIDs
	 * @param tree          						object - tree-data received from api
	 * @param routeIdentificationProperties        	object - tree-meta-data received from api
	 */
	ComponentTree.prototype.setRawTree = function(storage, routeID, route, routeComponentIDs, tree, routeIdentificationProperties = {}){
		// prevent duplicates of parameterized routes within rawTree cache.
		// e.g., /a, /a/1 and /a/2 resolves to /a/:ID? => the corresponding route's rawTree would be /a every time.
		routeIdentificationProperties = routeIdentificationProperties || {}
		const isNonParameterizedRoute = routeIdentificationProperties.path === routeIdentificationProperties.corePath
		const rawTreeRoute = routeIdentificationProperties.corePath || route

		if(appConfig.cache.reuseCachedRawTrees && utils.jsonpack && (isNonParameterizedRoute || (rawTreeRoute && !this.rawTrees[rawTreeRoute]))){
			if(routeID !== undefined){
				this.rawTrees[routeID] = utils.jsonpack.pack(tree);
				if(rawTreeRoute !== undefined){
					this.rawTrees[rawTreeRoute] = this.rawTrees[routeID];
				}
			}
			else if(rawTreeRoute !== undefined){
				this.rawTrees[rawTreeRoute] = utils.jsonpack.pack(tree);
			}
			if(utils.collectionSize(routeComponentIDs) > 0){
				this.rawTrees[`_routeComponentIDs_${routeComponentIDs.join('_')}`] = utils.jsonpack.pack(tree);
			}
		}
	};

	/**
	 * this function is used to build a given tree which includes normalization, template binding and (in case of a masterTree) server source binding.
	 *
	 * @param   route                           string - route name (will be used as key in buildMemory.trees)
	 * @param   tree                            object - raw component tree
	 * @param   isRootTree                      boolean - this flag is set to true if the actual tree is the tree which will be rendered if the browser will request an url. this fact is not met if the browser requests a tree to load it into a section.
	 * @param   isMasterTree                    boolean - is this the master tree
	 * @param   isBrowser                       boolean - is this a browser build call
	 * @param   storage                         object - actual storage
	 * @param   buildStates                     object - buildStatus collection which defines why the return value may be false
	 * @param   buildMemory                     object - optional - buildMemory object used to store built trees and rendered html
	 * @param   resourceLoaders                 object - actual resource loaders
	 * @param   resourceLoadersUsesOwnService 	boolean - should the resourceLoaders added by this build process use the own (true) or the foreign (false) service to load data by default (if not defined within a fieldConfig)?
	 * 											default: true
	 * @param   parentIsContainerComponent      boolean - is this a container component
	 * @param   prepareModelData                boolean - this flag decides if the model has to be prepared (atom to flag transformation) or not.
	 * @param   routePath                       string - optional routePath of corresponding route
	 * @param   buildFullApp                    boolean - optional - is this a full app build?
	 * @param   parentComponentIndex            int - index of parent component (may be used for component dynamic loading)
	 * @param   parentComponentInstanceID       int - id of parent component instance
	 * @param   inclusionComponentIndex	        boolean - predefined action components or inclusion components will set this parameter to true (this special components' indexes exist only on the client and will be negative)
	 * @param   inheritFallbackScope	        string - inherit this scope if there is no leaf.scope available. this comes in handy in case of static components (e.g., modals initialized on clients without any componentInstance in the database) or simply if the components should be usable in different scopes.
	 * 											this will never happen on the server-side. but if a client builds a component subTree without any scope information the scope of the component building the sub-tree sets this parameter.
	 * @returns mixed                           {} | boolean -  built tree or boolean build success (without any route given the built tree will be returned).
	 *                                                          the build success can be false in some cases (e.g., insufficient privileges, inactive state, empty tree given, ...)
	 */
	ComponentTree.prototype.build = function(route, tree, isRootTree, isMasterTree, isBrowser, storage, buildStates, buildMemory, resourceLoaders, resourceLoadersUsesOwnService, parentIsContainerComponent, prepareModelData, routePath, buildFullApp, parentComponentIndex, parentComponentInstanceID, inclusionComponentIndex, inheritFallbackScope){
		// init
		var isBaseInit          = (isMasterTree && !isBrowser || !isMasterTree && isBrowser);
		var result = true;

		// buildStates fallback just in case the build process is not interested in the buildStates
		if(buildStates === undefined || buildStates === null){
			buildStates = {};
		}

		// during race conditions it is possible that multiple build processes are interfering with one another via the buildMemory. (e.g., during media preparation)
		// to prevent problems the first one marks its buildMemory so the followups prevent their own buildMemory usage.
		// this leads to two things:
		// 		- first: the simultaneous processes perform the necessary work again
		// 		- second: the followups behave like they have been the first one ever since fec start processing the actual route.
		// NOTES:
		// 		- clients are allowed to resuse their own buildMemory what so ever.
		// 		- in case of raw component building (@see /server/frontendController.js.getBuiltComponent()) there is no route available. however, the buildMemory will be empty in these cases anyway.
		// 		- if the actual route has never been built there is no reason to prevent the result being saved in the permanent buildMemory.
		// 		- if the actual user prevents buildMemory from being reused this flag is obsolete. (e.g., if the users forces the preview mode reusing the buildMemory makes no sense)
		// 		- since this build function call by itself will be processed synchronously the buildMemoryInUseAtTheMoment-flag may be set at the end of this function.
		// 		- the finalizeBuild() method will reset the buildMemoryInUseAtTheMoment-flag afterwards to guarantee that all resource preloading logic and other preparations for this route have been completed.
		var buildMemoryReUsageGranted = isBrowser || !route || !this.trees[route] || !this.trees[route].buildMemoryInUseAtTheMoment;

		// buildMemory fallback just in case the build process should not memorize the actual built tree and rendered html
		if(buildMemory === undefined || buildMemory === null){
			buildMemory = storage.buildMemory = {};

			if(appConfig.cache.storeBuildMemoryPermanently && buildMemoryReUsageGranted && (appConfig.isClient || storage.user.cacheUsageGranted())){
				buildMemory.trees 	= this.trees;
				buildMemory.mapping = this.mapping;
				buildMemory.html 	= this.html;
			}
		}
		if(!buildMemory.trees || !buildMemoryReUsageGranted) 	buildMemory.trees = {};
		if(!buildMemory.mapping || !buildMemoryReUsageGranted) 	buildMemory.mapping = {};
		if(!buildMemory.html || !buildMemoryReUsageGranted)  	buildMemory.html = {};

		var environment = {};
		if(storage.user && storage.user.data && storage.user.data.environment){
			environment = storage.user.data.environment;
		}

		// build and return tree within client-side code, so the client can decide where the sub tree should be saved
		if(utils.isEmpty(route)){
			// fallback
			if(utils.isEmpty(tree)){
				result = {};
			}
			else {
				var builtTree = this.buildLeaf(tree, '', undefined, parentComponentIndex, parentComponentInstanceID, undefined, isRootTree, isBaseInit, isBrowser, storage, environment, buildStates, false, undefined, resourceLoaders, resourceLoadersUsesOwnService, parentIsContainerComponent, prepareModelData, (isRootTree ? undefined : routePath), undefined, { scope: inheritFallbackScope }, inclusionComponentIndex, {}, buildMemory, buildFullApp, undefined);

				if(!builtTree){
					result = false;
				}
				else {
					// reset buildStates in case of success
					utils.map(buildStates, function(status, statusKey){
						if(statusKey === 'privilegeCode') return undefined;
						return false;
					});

					if(!utils.isEmpty(builtTree.shadowComponents)){
						// TODO: ERROR HANDLING
						console.log('SHADOW COMPONENTS NOT ASSIGNED TO ANY COMPONENT', builtTree.shadowComponents);
					}
					if(parentIsContainerComponent && builtTree.potentialContainerComponentClasses){
						builtTree.leaf.potentialContainerComponentClasses = builtTree.potentialContainerComponentClasses;
					}
					result = builtTree.leaf;
				}
			}
		}
		// build master tree
		else if(
			(!appConfig.isClient && !appConfig.cache.reuseCachedBuilds) ||
			utils.isEmpty(buildMemory.trees[route]) ||
			!buildMemory.trees[route].readyToServeFromCache ||
			(
				buildMemory.routeIdentificationProperties
				&&
				buildMemory.routeIdentificationProperties.coreRoute !== buildMemory.routeIdentificationProperties.fullParamRoute
			) ||
			storage.user.data.isPrewarmProcess ||
			!buildMemory.trees[route].minFuturePeriodChangeAt ||
			buildMemory.trees[route].minFuturePeriodChangeAt < storage.user.getReferenceTS()
		) {
			// fallback
			if(utils.isEmpty(tree)){
				result = {};
			}
			else {

				// is this a routeID?
				if(route == parseInt(route)){
					route = this.extractPath(tree);
				}
				// does there exist a corePath to be built instead?
				// TODO: this might only be necessary in some special cases. maybe client-side. the route param should be the corePath anyway!
				else if((this.routeIdentificationMapping[route] || {}).corePath){
					route = this.routeIdentificationMapping[route].corePath
				}

				var commonRouteInfo = {};

				// build tree
				var builtTree = this.buildLeaf(tree, route, undefined, parentComponentIndex, parentComponentInstanceID, undefined, isRootTree, isBaseInit, isBrowser, storage, environment, buildStates, false, undefined, resourceLoaders, resourceLoadersUsesOwnService, parentIsContainerComponent, prepareModelData, (isRootTree ? undefined : routePath), undefined, { scope: inheritFallbackScope }, inclusionComponentIndex, commonRouteInfo, buildMemory, buildFullApp);

				if(!builtTree){
					result = false;
				}
				else {
					// reset buildStates in case of success
					utils.map(buildStates, function(status, statusKey){
						if(statusKey === 'privilegeCode') return undefined;
						return false;
					});

					if(!utils.isEmpty(builtTree.shadowComponents)){
						// TODO: ERROR HANDLING
						console.log('SHADOW COMPONENTS NOT ASSIGNED TO ANY COMPONENT', builtTree.shadowComponents);
					}

					if(isBrowser) {
						buildMemory.trees[builtTree.routePath] = builtTree.leaf;
					}
					// usually there is a routePath except when globalShadowContainers are built
					else if(builtTree.routePath) {
						// speed up garbage collection
						delete buildMemory.trees[builtTree.routePath];

						buildMemory.trees[builtTree.routePath] 								= buildMemory.mapping[builtTree.leaf.path];
						buildMemory.trees[builtTree.routePath].finalizeOptions 				= utils.replace(builtTree, { leaf: undefined, isRootTree: isRootTree });
						buildMemory.trees[builtTree.routePath].commonRouteInfo 				= commonRouteInfo;
						buildMemory.trees[builtTree.routePath].buildMemoryInUseAtTheMoment 	= true;

						// set prewarmID if necessary
						if(storage.user.data.prewarmID) buildMemory.trees[builtTree.routePath].prewarmID = storage.user.data.prewarmID;

						if(builtTree.leaf.routeID){
							// speed up garbage collection
							delete buildMemory.trees[builtTree.leaf.routeID];

							// save reference to tree by routeID
							buildMemory.trees[builtTree.leaf.routeID] = buildMemory.trees[builtTree.routePath];
						}
					}
				}
			}
		}

		return result;
	};

	/**
	 * this function is used to finalize a build.
	 * NOTE: this is necessary to get all data inserted into the tree before it can be delivered to the client.
	 *
	 * @param 	tree			object - tree to deliver
	 * @param 	storage			object - actual storage
	 * @param   routeParams		object - parameters defined by the actual route-call
	 * @param   queryParams		object - query parameters - optional
	 * @param   buildMemory     object - optional - buildMemory object used to store built trees and rendered html
	 * @returns boolean - success
	 */
	ComponentTree.prototype.finalizeBuild = function(tree, storage, routeParams, queryParams, buildMemory){
		if((tree || {}).finalizeOptions){
			var route 					= buildMemory.trees[tree.finalizeOptions.routePath];
			var layoutComponentModel 	= (route.children[tree.finalizeOptions.childLayoutIndex || 0] || {}).model || {};
			var renderMemory 			= {};

			// reset buildMemoryInUseAtTheMoment flag for the actual route. @see build() method for further details.
			route.buildMemoryInUseAtTheMoment = false;

			// save childLayoutIndex
			route.childLayoutIndex = tree.finalizeOptions.childLayoutIndex;

			// include tree structure and templates for clients
			if(tree.finalizeOptions.isRootTree && typeof(tree.finalizeOptions.childLayoutIndex) != 'undefined' && tree.finalizeOptions.childLayoutIndex >= 0 && buildMemory.trees[tree.finalizeOptions.routePath].children.length > tree.finalizeOptions.childLayoutIndex){
				layoutComponentModel.fullRoute             	= (buildMemory.routeIdentificationProperties || {}).fullParamRoute;
				layoutComponentModel.route                	= tree.finalizeOptions.routePath;
				layoutComponentModel.routeConfig 			= (buildMemory.trees[tree.finalizeOptions.routePath].config || {}).routeConfig || {};
				layoutComponentModel.routeOptions 			= {
					isAppPart: 	!!buildMemory.trees[tree.finalizeOptions.routePath].isAppPart,
					isHome: 	!!buildMemory.trees[tree.finalizeOptions.routePath].isHome,
				};
				layoutComponentModel.upStartTimestamp     	= storage.app.upStartTimestamp;
			}

			// execute prepare if necessary
			this.executeOn(buildMemory.trees[tree.finalizeOptions.routePath], 'prepare', {
				storage: storage,
				isServer: true,
				options: {
					buildMemory: 		buildMemory,
					refComponentTree: 	this,
					routePath: 			tree.finalizeOptions.routePath
				}
			}, true);

			// refine minFuturePeriodChangeAt by components which want to have a voice on the cache matter
			if(appConfig.cache.reuseCachedHtml){
				var userReferenceTS = storage.user.getReferenceTS();
				this.forEachLeaf(buildMemory.trees[tree.finalizeOptions.routePath], true, function(leaf){
					var minFuturePeriodChangeAt;
					if(
						typeof leaf.getMinFuturePeriodChangeAt === 'function' &&
						(minFuturePeriodChangeAt = leaf.getMinFuturePeriodChangeAt(storage)) > userReferenceTS &&
						(
							!storage.request.minFuturePeriodChangeAt ||
							storage.request.minFuturePeriodChangeAt > minFuturePeriodChangeAt
						)
					){
						storage.request.minFuturePeriodChangeAt = minFuturePeriodChangeAt;
					}
				})
			}

			// save minFuturePeriodChangedAt if necessary
			if(storage.request.minFuturePeriodChangeAt){
				route.minFuturePeriodChangeAt = storage.request.minFuturePeriodChangeAt;
			}

			// reset html cache if necessary
			if(appConfig.cache.reuseCachedHtml && !appConfig.cache.preWarmRoutes && (buildMemory.html || {})[tree.finalizeOptions.routePath]){
				delete buildMemory.html[tree.finalizeOptions.routePath];
			}

			// prepare include actions before componentTreeDelivery if necessary
			if(appConfig.useFecClient){
				this.render(tree.finalizeOptions.routePath, storage, routeParams, undefined, buildMemory, renderMemory, false);

				// prevent writing caches if inclusions has been performed.
				// complete the tree instead.
				if(renderMemory.inclusionPerformed){
					// include tree structure and templates for clients
					if(tree.finalizeOptions.isRootTree && typeof(tree.finalizeOptions.childLayoutIndex) != 'undefined' && tree.finalizeOptions.childLayoutIndex >= 0 && buildMemory.trees[tree.finalizeOptions.routePath].children.length > tree.finalizeOptions.childLayoutIndex){
						delete layoutComponentModel.routeConfig;
						delete layoutComponentModel.routeOptions;
						delete layoutComponentModel.route;
						delete layoutComponentModel.upStartTimestamp;

						layoutComponentModel.fullRoute             	= (buildMemory.routeIdentificationProperties || {}).fullParamRoute;
						layoutComponentModel.route                	= tree.finalizeOptions.routePath;
						layoutComponentModel.routeConfig 			= (buildMemory.trees[tree.finalizeOptions.routePath].config || {}).routeConfig || {};
						layoutComponentModel.routeOptions 			= {
							isAppPart: 	!!buildMemory.trees[tree.finalizeOptions.routePath].isAppPart,
							isHome: 	!!buildMemory.trees[tree.finalizeOptions.routePath].isHome,
						};
						layoutComponentModel.upStartTimestamp     	= storage.app.upStartTimestamp;
					}
				}
				// write down the render memory to prevent additional render calls if possible
				else {
					buildMemory.html[tree.finalizeOptions.routePath] = renderMemory;
				}
			}

			// cleanup
			delete tree.finalizeOptions;
		}

		return true;

	};


	/**
	 * this function is used to update some layout model parameters used even if the build has been cached already.
	 *
	 * @param 	tree			object - tree to deliver
	 * @param 	storage			object - actual storage
	 * @param   routeParams		object - parameters defined by the actual route-call
	 * @param   queryParams		object - query parameters - optional
	 * @param   willBeRendered  boolean - will the given tree be delivered as json or will it be rendered
	 * @returns boolean - success
	 */
	ComponentTree.prototype.updateBuiltLayoutModel = function(tree, storage, routeParams, queryParams, willBeRendered){
		if(appConfig.isServer && appConfig.useFecClient && tree){
			const layoutComponent 			= tree.children[tree.childLayoutIndex || 0] || {}
			const layoutComponentModel 	= layoutComponent.model || {}

			// reset vars
			delete layoutComponentModel.tree
			delete layoutComponentModel.globalActionsByScope
			delete layoutComponentModel.routeParams
			delete layoutComponentModel.queryParams
			delete layoutComponentModel.updateClientStorage

			if(layoutComponentModel){
				if(willBeRendered){
					layoutComponentModel.tree 					= JSON.stringify(tree)
					layoutComponentModel.globalActionsByScope 	= JSON.stringify(this.globalActionsByScope)
					layoutComponentModel.routeParams 			= JSON.stringify(routeParams)
					layoutComponentModel.queryParams 			= JSON.stringify(queryParams)
					layoutComponentModel.updateClientStorage 	= JSON.stringify(storage.filterClientData())
				} else {
					layoutComponentModel.routeParams 			= routeParams
					layoutComponentModel.queryParams 			= queryParams
					layoutComponentModel.updateClientStorage 	= storage.filterClientData()
				}
			}
		}
	};

	/**
	 * this function is used to build a given leaf and all of its children recursive. it returns the fully leaf.
	 *
	 * @param   leaf                        	object - leaf (component data)
	 * @param   originalRoute               	string - route to build
	 * @param   parentRouteID               	int - parentRouteID
	 * @param   parentComponentIndex        	string - index of parent component
	 * @param   parentComponentInstanceID   	int - id of parent component instance
	 * @param   parentRouteActions				object - optional - if parentRouteActions are defined they should be available within the child-leafs of the route
	 * @param   isRootTree                  	boolean - this flag is set to true if the actual tree is the tree which will be rendered if the browser will request an url. this fact is not met if the browser requests a tree to load it into a section.
	 * @param   isBaseInit                  	boolean - should the components be normalized or not
	 * @param   isBrowser                   	boolean - is this a browser or the server
	 * @param   storage                     	object - actual storage
	 * @param   environment                 	object - actual known environment
	 * @param   buildStates                 	object - buildStatus collection which defines why the return value may be false
	 * @param   buildAborted                	boolean - has the parent leaf been aborted according to status, privilegeCode or one of the periods
	 * @param   resourceDependencyParent    	int - this flag is set if the actual component has a resource dependency of one of its' parent components.
	 *                                     		if the flag is not undefined it contains the corresponding parent components' componentIndex.
	 * @param   resourceLoaders             	object - actual resourceLoaders
	 * @param   resourceLoadersUsesOwnService 	boolean - should the resourceLoaders added by this build process use the own (true) or the foreign (false) service to load data by default (if not defined within a fieldConfig)?
	 * 											default: true
	 * @param   parentIsContainerComponent  	boolean - is this a container component
	 * @param   prepareModelData            	boolean - this flag decides if the model has to be prepared (atom to flag transformation) or not.
	 * @param   routePath                   	string - this is the actual route path according to the built route-components
	 * @param   parentRouteData             	object - the route-components' data which has to be copied to the underlying layout-component (model, actions, ...)
	 * @param   parentLeafInfo 					object - the parent-leafs information needed for inheritance and miscellaneous features (e.g., scope)
	 * @param   inclusionComponentIndex	  		boolean - predefined action components or inclusion components will should set this parameter to true (this special components' indizes extist only on the client will be set negative)
	 * @param   commonRouteInfo					object - this flag is a collection of route information needed for miscellaneous features (e.g., breadcrumbs, ...)
	 * @param   buildMemory     				object - optional - buildMemory object used to store built trees and rendered html
	 * @param   buildFullApp                    boolean - optional - is this a full app build?
	 * @param   isShadowOrChildOfOne			boolean - optional - isShadowComponent or a child of one (directly or indirectly)
	 * @param   parentPostponesChildren         boolean - optional - if this is set to true only necessary extractions would be performed on the actual leaf and its children. (e.g., shadow components or action definitions would be registered).
	 *                                          this is useful if a component will never be rendered on the server but should be built in the fec-client. e.g., base_form_relationship children for event.registrationForm.
	 * @returns object                     	    built leaf
	 */
	ComponentTree.prototype.buildLeaf = function(leaf, originalRoute, parentRouteID, parentComponentIndex, parentComponentInstanceID, parentRouteActions, isRootTree, isBaseInit, isBrowser, storage, environment, buildStates, buildAborted, resourceDependencyParent, resourceLoaders, resourceLoadersUsesOwnService, parentIsContainerComponent, prepareModelData, routePath, parentRouteData, parentLeafInfo, inclusionComponentIndex, commonRouteInfo, buildMemory, buildFullApp, isShadowOrChildOfOne, parentPostponesChildren){
		// prevent errors according to erroneous leaf definitions
		if(utils.isCollection(leaf)){
			if(!buildAborted){
				// scope inheritance is granted for all leafs except sectionComponents.
				// however, if a sectionComponent gets a scope the children have to inherit it anyway.
				if(
					!leaf.scope &&
					parentLeafInfo.scope && (
						!(leaf.type === 'component' && !!leaf.sectionComponentID) ||
						parentLeafInfo.isSectionComponent
					)
				){
					leaf.scope = parentLeafInfo.scope;
				}

				// collect actual build states if necessary
				const {
					referenceTimestamp,
					states
				} = this.getLeafBuildStates(leaf, storage, isBrowser)
				const actualBuildStates = states

				// extend buildStates by privilegeCode if privilege has not been granted to this user
				if(actualBuildStates.privilege){
					actualBuildStates.privilegeCode = undefined;
					actualBuildStates.scope = undefined;
				}
				else {
					actualBuildStates.privilegeCode = leaf.privilegeCode;
					actualBuildStates.scope = leaf.scope;
				}

				// estimate minFuturePeriodChangeAt timestamp
				if((leaf.periodStart && leaf.periodStart > referenceTimestamp && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > leaf.periodStart))){
					storage.request.minFuturePeriodChangeAt = leaf.periodStart;
				}
				if((leaf.periodEnd && leaf.periodEnd > referenceTimestamp && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > leaf.periodEnd))){
					storage.request.minFuturePeriodChangeAt = leaf.periodEnd;
				}

				// should the leaf be built or not?
				if(!(
					actualBuildStates.status
					&&
					actualBuildStates.privilege
					&&
					actualBuildStates.period
				)){
					utils.refReplace(buildStates, actualBuildStates);
					buildAborted = true;
				}
			}

			// import parentRoute actions in case of route-cascades
			if(!parentRouteActions) parentRouteActions = {};
			if(leaf.type === 'route'){
				if(leaf.actions) {
					utils.refReplace(parentRouteActions, leaf.actions);
				}

				if(!commonRouteInfo.breadCrumbs) commonRouteInfo.breadCrumbs = [];
				commonRouteInfo.breadCrumbs.push({
					isHome: leaf.isHome || false,
					config: leaf.config || {},
					model: leaf.model || {},
					path: leaf.path || '',
					routeID: leaf.routeID || 0,
					subType: leaf.subType
				});

				// set lang according to route if necessary
				// NOTE: 	since app-componentTrees usually do not contain any language-nodes we use them to identify
				// 			if the actual build and render function-calls of this very route has to overwrite the user's langCode decision.
				// TODO: POIA: check this fucker. again.
				if(leaf.subType === 'language' && leaf.langCode && leaf.langCode !== storage.langCode){
					buildMemory.overwriteByRouteLangCode = leaf.langCode
					storage = store.getLanguageCopy(storage, leaf.langCode)
				}
			}

			// handle proxyCacheScope
			let proxyCacheScope
			if(
				storage.isServer &&
				storage.proxyCacheController &&
				(
					leaf.type === 'route'
					||
					leaf.type === 'component'
				)
			){
				proxyCacheScope = storage.proxyCacheController.getScope(leaf)
				storage.proxyCacheController.scopeStart(proxyCacheScope)
			}

			// prepare leaf
			try {
				leaf = this.prepareLeaf(leaf, routePath, parentRouteID, parentComponentIndex, parentComponentInstanceID, parentRouteActions, isRootTree, isBaseInit, isBrowser, storage, environment, buildAborted, resourceDependencyParent, resourceLoaders, resourceLoadersUsesOwnService, prepareModelData, parentRouteData, parentLeafInfo || {}, inclusionComponentIndex, (isShadowOrChildOfOne || (leaf.config || {}).isShadowComponent), parentPostponesChildren);
			} catch (error){
				console.log(error);
			}

			// if the prepared leaf is no object it equals to a leaf.isBuildGranted() return value.
			// @see CONSTANTS.COMPONENT:BUILD_GRANTED for further details.
			if(!utils.isCollection(leaf)){

				// handle proxyCacheScope
				if(proxyCacheScope){
					storage.proxyCacheController.scopeAbort(proxyCacheScope)
					storage.proxyCacheController.scopeDelete(proxyCacheScope, false)
				}

				return leaf;
			}

			if(leaf.type === 'component') inclusionComponentIndex = false;

			var routeData = {};
			if (leaf.type === 'route') {
				routePath 		= leaf.path;
				parentRouteID 	= leaf.routeID;

				if(CONSTANTS.RENDER_ROUTE_SUB_TYPES[leaf.subType] || CONSTANTS.RENDER_ROUTE_SUB_TYPES[String(leaf.subType).split('_')[0] || 'UNKNOWN']){
					routeData = {
						model: utils.replace(leaf.model || {}, { routeID: leaf.routeID }),
						actions: leaf.actions || {}
					};
				}
			}

			const leafInfo = {
				scope: leaf.scope,
				isSectionComponent: leaf.type === 'component' && !!leaf.sectionComponentID
			}

			// MARK: POSTPONE_CHILDREN_PRE_BUILD
			// if a component's children are used to create (possibly multiple) instances at the client's performAction process there is no need for further building them.
			// e.g., a base_form_relationship is dependent on it's location within the tree and may be initialized multiple times like event-system's participantProperties.
			// to prevent multiple needless builds and further more sanitizeResources-calls th postponeChildren-feature has been added.
			// NOTE: 	the server has to build the children in postpone-mode to extract potential action definitions, shadowComponents etc.
			// 			the client should not bother to build these children.
			const postponeChildren = leaf.type === 'component' && (leaf.config || {}).postponeChildren
			if(isBrowser && postponeChildren && (leaf.children || []).length > 0){
				leaf.postponedChildren = leaf.children;
				leaf.children = []
			}

			// build children (early decending)
			var childRouteIndex = -1;
			var childLayoutIndex = -1;
			var shadowComponents = {};
			var childComponentDeletionCounter = 0;
			var nrOfChildren = (leaf.children || []).length;
			var potentialContainerComponentClasses = [];
			var containerComponentClass = [];
			var isContainerComponent = (leaf.type === 'component' && leaf.config && leaf.config.isContainerComponent) || (leaf.type === 'section' && parentIsContainerComponent);
			var originalRouteHidden = false;
			var originalRouteBuildStates;
			if(parentIsContainerComponent && leaf.type === 'component'){
				containerComponentClass = (leaf.componentClass + (!utils.isEmpty(leaf.extensionComponentClass) ? ' ' + leaf.extensionComponentClass : '')).split(' ');
				utils.map(containerComponentClass, function(clazz){
					return 'container_' + clazz;
				});
				if((leaf.config || {}).additionalContainerComponentClasses){
					containerComponentClass = containerComponentClass.concat(utils.collectionValues(leaf.config.additionalContainerComponentClasses));
				}
				potentialContainerComponentClasses.push(containerComponentClass.join(' '));
			}
			var nextParentComponentIndex;
			var nextParentComponentInstanceID;
			var childIndex;
			for (childIndex = 0; childIndex < nrOfChildren; childIndex++){
				nextParentComponentIndex = parentComponentIndex;
				nextParentComponentInstanceID = parentComponentInstanceID;
				if(leaf.type === 'component'){
					nextParentComponentIndex = leaf.componentIndex;
					nextParentComponentInstanceID = leaf.componentInstanceID;
				}
				else if(leaf.type === 'route'){
					nextParentComponentInstanceID = leaf.path;
				}

				var builtComponent = this.buildLeaf(
					leaf.children[childIndex-childComponentDeletionCounter],
					originalRoute,
					parentRouteID,
					nextParentComponentIndex,
					nextParentComponentInstanceID,
					leaf.type === 'route' ? parentRouteActions : {},
					isRootTree,
					isBaseInit,
					isBrowser,
					storage,
					environment,
					buildStates,
					buildAborted,
					(
						// use actual leaf as resource-boss, because ...
						(
							(
								// ... of its' dataDealer
								(leaf.hasDataDealer && !leaf._dataDealerCalled)
								||
								// ... of its' resourceRegisterContent
								(leaf.config && leaf.config.resourceRegisterKey && !leaf._resourceRegisterSanitationDone)
							) ? leaf.componentIndex : undefined
						)
						||
						// use previous dataDealer-Boss
						resourceDependencyParent
					),
					resourceLoaders,
					resourceLoadersUsesOwnService,
					isContainerComponent,
					prepareModelData,
					routePath,
					routeData,
					leafInfo,
					inclusionComponentIndex,
					commonRouteInfo,
					buildMemory,
					buildFullApp,
					(isShadowOrChildOfOne || (leaf.config || {}).isShadowComponent),
					parentPostponesChildren || postponeChildren
				);

				// ensure that the child has been built.
				// can be false in case of status problems, privilege problems, ...
				// can be a buildGranted state: @see CONSTANTS.COMPONENT:BUILD_GRANTED for further details.
				if(builtComponent && utils.isCollection(builtComponent)){
					// concat childrens' potential container component classes if necessary
					if(isContainerComponent && !utils.isEmpty(builtComponent.potentialContainerComponentClasses)){
						potentialContainerComponentClasses.concat(builtComponent.potentialContainerComponentClasses);
					}

					// set child index identifying the child which represents a route
					if(builtComponent.isRoute) childRouteIndex = childIndex-childComponentDeletionCounter;
					// set child index identifying the child which represents the routes layout
					if(builtComponent.isLayout || builtComponent.alternativeChildLayoutIndexInCharge) childLayoutIndex = childIndex-childComponentDeletionCounter;
					// set child index identifying the child which represents the routes layout of the final page route
					else if (builtComponent.isRoute) childLayoutIndex = builtComponent.childLayoutIndex;

					// preset inclusion shadow components
					if(!utils.isEmpty(builtComponent.inclusionShadowComponent)) {
						if(!leaf.inclusionShadowComponents) leaf.inclusionShadowComponents = {};
						leaf.inclusionShadowComponents[builtComponent.inclusionShadowComponent.config.codeName] = builtComponent.inclusionShadowComponent;
					}
					// save list of shadow component codenames
					if(!utils.isEmpty(builtComponent.shadowComponents)) {
						// TODO: ERROR LOG IF SHADOW COMPONENT ALREADY EXISTS
						shadowComponents = utils.replace(shadowComponents, builtComponent.shadowComponents);
					}
					// save leafs
					if(builtComponent.leaf !== undefined) {
						leaf.children[childIndex-childComponentDeletionCounter] = builtComponent.leaf;

						routePath = builtComponent.routePath;
					}
					// unset leaf if shadow component has been built
					else {
						leaf.children.splice(childIndex-childComponentDeletionCounter, 1);
						childComponentDeletionCounter++
					}
				}
				else {
					if(leaf.children[childIndex-childComponentDeletionCounter].type === 'route' && originalRoute.indexOf(leaf.children[childIndex-childComponentDeletionCounter].path) === 0){
						originalRouteHidden = true;
						originalRouteBuildStates = utils.simpleCopy(buildStates);
					}
					leaf.children.splice(childIndex-childComponentDeletionCounter, 1);
					childComponentDeletionCounter++

					// if a component decides not to be built it may have decided if the decision is cacheable or not.
					if(builtComponent === CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.NO){
						if(leaf.type === 'component'){
							leaf.config.isCacheable = false
						} else {
							leaf.isCacheable = false
						}
					}
				}
			}

			// extract postponed children from normal tree. @see MARK: POSTPONE_CHILDREN_PRE_BUILD for details.
			if(!isBrowser && postponeChildren && (leaf.children || []).length > 0){
				leaf.postponedChildren = leaf.children;
				leaf.children = []
			}

			// build has been aborted according to status, privilegeCode or one of the period-fields
			if(buildAborted){
				// handle proxyCacheScope
				if(proxyCacheScope){
					storage.proxyCacheController.scopeAbort(proxyCacheScope)
					storage.proxyCacheController.scopeDelete(proxyCacheScope, false)
				}
				return false;
			}

			// handle proxyCacheScope
			if(proxyCacheScope){
				storage.proxyCacheController.scopeEnd(proxyCacheScope)
			}

			// TODO: DOC
			if (leaf.type === 'route'){
				// cleanup actions from routes
				leaf = utils.replace(leaf, { actions: undefined })

                if(leaf.routeLanguageConnections){
                    this.prepareRouteLanguageConnections(leaf.routeLanguageConnections, storage)
                }

				var isFinalPage = buildFullApp || (CONSTANTS.RENDER_ROUTE_SUB_TYPES[leaf.subType] || CONSTANTS.RENDER_ROUTE_SUB_TYPES[String(leaf.subType).split('_')[0] || 'UNKNOWN']) && (leaf.path == routePath && leaf.path == originalRoute)
				// save mapping for routes to be able to resolve shadow component codenames within them
				if(!isBrowser && (!buildMemory.mapping[leaf.path] || isFinalPage)){
					// TODO: 	shadowComponentCodeName => componentInstanceID mapping should survive multiple builds of the same component or route due to mappings which are built within a buildCache every time a scopeRole builds a privilege restricted component and / or route.
					// 			if not a shadowComponent may not be found by a scopeRole if another scopeRole builds the latest version of the corresponding leaf within a shared buildMemory.
					// 			maybe it would be wise to organize the buildMemory as a whole scopeRoleVersion dependent.
					// 			e.g., backoffice invoiceController within /main/office => boss loads page => unauthenticated or minion scopeRole loads page => boss opens invoiceController => 404 shadowNotFound
					buildMemory.mapping[leaf.path] = leaf
				}

				// actual component is no shadow component
				leaf.shadowComponents = utils.replace(leaf.shadowComponents || {}, shadowComponents)

				if(originalRouteHidden){
					utils.refReplace(buildStates, originalRouteBuildStates);
					return false;
				}
				else {
					// this is the final page route leaf
					if(isFinalPage){
						return {
							routePath: routePath,
							// leaf: leaf,
							leaf: utils.replace(leaf, {
								status: 		            undefined,
								periodStart: 	            undefined,
								periodEnd: 		            undefined
							}),
							isRoute: true,
							isLayout: false,
							childLayoutIndex: childLayoutIndex
						};
					}
					// non-final page route leaf found but childRouteIndex set properly
					else if(childRouteIndex >= 0){
						// estimated childRouteIndex exists
						if(leaf.children.length > childRouteIndex){
							if(leaf.path === '/'){
								// the upper parent route / has to propagate its shadow component mapping to the final page route leaf
								leaf.children[0].shadowComponents = utils.replace(leaf.shadowComponents, leaf.children[0].shadowComponents);
							}

							return {
								routePath: routePath,
								leaf: leaf.children[childRouteIndex],
								shadowComponents: leaf.path != '/' ? leaf.shadowComponents : undefined,
								isRoute: true,
								isLayout: false,
								childLayoutIndex: childLayoutIndex
							};
						}
						else {
							// routeChildIndex is invalid
							throw new Error('TREE_BUILD_ERROR_CAUSED_BY_ROUTE_2');
						}
					}
					// this is a parent route leaf without childRouteIndex
					else {
						throw new Error('TREE_BUILD_ERROR_CAUSED_BY_ROUTE_1');
					}
				}
			}
			else if (leaf.type === 'section'){
				return {
					routePath:                          routePath,
					leaf:                               leaf,
					shadowComponents:                   shadowComponents,
					potentialContainerComponentClasses: potentialContainerComponentClasses,
					isRoute:                            false,
					isLayout:                           false
				};
			}
			// is component
			else if(leaf instanceof Component || parentPostponesChildren){

				// save leaf lookup or mapping
				if(isBrowser){
					if(this.lookup[leaf.componentIndex] !== undefined && this.lookup[leaf.componentIndex].componentIndex != leaf.componentIndex){
						console.error('componentIndex already in use' + leaf.componentIndex);
					}
					this.lookup[leaf.componentIndex] = leaf;

					// manage intermediary children lookup
					if(leaf.intermediaryParentComponentIndex && this.lookup[leaf.intermediaryParentComponentIndex]){
						this.lookup[leaf.intermediaryParentComponentIndex].intermediaryChildren = this.lookup[leaf.intermediaryParentComponentIndex].intermediaryChildren || {}
						this.lookup[leaf.intermediaryParentComponentIndex].intermediaryChildren[leaf.componentIndex] = this.lookup[leaf.componentIndex]
					}
				}
				// save ordinary component mapping
				else {
					// TODO: 	shadowComponentCodeName => componentInstanceID mapping should survive multiple builds of the same component or route due to mappings which are built within a buildCache every time a scopeRole builds a privilege restricted component and / or route.
					// 			if not a shadowComponent may not be found by a scopeRole if another scopeRole builds the latest version of the corresponding leaf within a shared buildMemory.
					// 			maybe it would be wise to organize the buildMemory as a whole scopeRoleVersion dependent.
					// 			e.g., backoffice invoiceController within /main/office => boss loads page => unauthenticated or minion scopeRole loads page => boss opens invoiceController => 404 shadowNotFound
					buildMemory.mapping[leaf.componentInstanceID] = leaf;

					// the mapping of shadow components has to respect the scope and scopeRole of the actual user
					if(leaf.config && leaf.config.isShadowComponent) {
						if(!this.shadowMapping[leaf.componentInstanceID]) this.shadowMapping[leaf.componentInstanceID] = { scope: leaf.scope || '', scopeRoleVersions: {} };

						var scopeRoleID = '~';
						if(
							leaf.scope &&
							storage.user.data &&
							storage.user.data.rolesConfigs &&
							storage.user.data.rolesConfigs[leaf.scope] &&
							storage.user.data.rolesConfigs[leaf.scope].scopeRoleID
						){
							scopeRoleID = storage.user.data.rolesConfigs[leaf.scope].scopeRoleID;
						}

						this.shadowMapping[leaf.componentInstanceID].scopeRoleVersions[scopeRoleID] = leaf;
					}
				}

				// actual component is no shadow component
				leaf.shadowComponents = utils.replace(leaf.shadowComponents || {}, shadowComponents);

				// save routePath within each component
				leaf._routePath = leaf._routePath || routePath;

				// shadow leafs will be saved separately
				if(!utils.isEmpty(leaf.config.isShadowComponent)){
					const result = {
						shadowComponents: {}
					}
					result.shadowComponents[leaf.config.codeName] = leaf.componentInstanceID

					if(!utils.isEmpty(leaf.config.isInclusionShadow)){
						result.inclusionShadowComponent = leaf
					}

					return result
				}

				// mark leafs as built if necessary
				// TODO: this note should be reworked in fec.v5
				// NOTE: this will be used in cases of trees which will be loaded, built, copied to the contents of another component and would be built another time (e.g., /website/routeTree into tabContent of tab)
				if(isBrowser) leaf.isBuilt = true;

				// set container component classes for actual leaf if necessary
				if(leaf.config.isContainerComponent){
					leaf.containerComponentClass = potentialContainerComponentClasses.join(' ');
				}

				var wasLayout = leaf.type === 'layout';
				if(!leaf.isVisible && utils.collectionSize(leaf.children) == 1){
					childIndex = Object.keys(leaf.children)[0];
					if(leaf.children[childIndex].type === 'section' && utils.collectionSize(leaf.children[childIndex].children) == 1){
						var subChildIndex = Object.keys(leaf.children[childIndex].children)[0];
						leaf = leaf.children[childIndex].children[subChildIndex];
						leaf.parentComponentInstanceID = parentComponentInstanceID;
						return {
							routePath: routePath,
							leaf: leaf,
							isRoute: false,
							alternativeChildLayoutIndexInCharge: true,
							potentialContainerComponentClasses: []
						};
					}
				}

				return {
					routePath: routePath,
					leaf: leaf,
					isRoute: false,
					isLayout: (leaf.subType === 'layout' || wasLayout),
					potentialContainerComponentClasses: parentIsContainerComponent ? potentialContainerComponentClasses : []
				};
			}
			// is global shadow container
			// TODO: POIA: CLEANUP
			else if(leaf.type === 'globalShadowContainer'){
				const {
					scope,
					// key
				} = leaf || {}
				const scopeKey = scope || '~'
				if(!scope){
					// TODO: POIA: stress?
				}
				// if(!key){
				// 	// TODO: POIA: stress
				// }

				this.globalShadowsByScope[scopeKey] = this.globalShadowsByScope[scopeKey] || {
					shadowComponents: {}
				}
				utils.refReplace(this.globalShadowsByScope[scopeKey].shadowComponents, leaf.shadowComponents || {}, shadowComponents);
				// this.globalShadowsByScope[scopeKey][key] = leaf
			}
		}

		// error- / base-case
		return leaf;
	};

	/**
	 * if a route and its coreRoute differs the corresponding routeIdentificationProperties will be stored within this.routeIdentificationMapping[<fullPath|routeTemplateMappingKey>] = <routeIdentificationProperties>
	 *
	 * @param tree		object - api-raw-tree
	 * @returns {object} routeIdentificationProperties
	 */
	ComponentTree.prototype.setRouteIdentificationMapping = function(tree){
		const routeIdentificationProperties = (tree || {}).routeIdentificationProperties || {}
		if(routeIdentificationProperties.path !== routeIdentificationProperties.corePath){
			// since path is dependent on a route being loaded via routePath there is a special case.
			// if the route is loaded via templateCodeName the corePath has been identified by the api, but the requested routePath is false.
			this.routeIdentificationMapping[routeIdentificationProperties.path || routeIdentificationProperties.corePath] = routeIdentificationProperties

			if(routeIdentificationProperties.routeParamsExtension){
				const routeParamsValues = utils.trim(utils.trim(String(routeIdentificationProperties.path), ' /').substring(utils.trim(routeIdentificationProperties.corePath, ' /').length), ' /').split('/')
				const routeParamsNames = utils.trim(routeIdentificationProperties.routeParamsExtension, ' /').split('/')
				const routeParams = {}
				for(const paramIndex in routeParamsNames){
					if(routeParamsValues[paramIndex] !== undefined){
						routeParams[utils.trim(routeParamsNames[paramIndex], ' :?')] = routeParamsValues[paramIndex]
					}
				}

				routeIdentificationProperties.routeParams = routeParams
			}
		}
		if (routeIdentificationProperties.routeTemplateCodeName){
			this.routeIdentificationMapping[this.getRouteTemplateMappingKey(routeIdentificationProperties.routeTemplateCodeName, routeIdentificationProperties.routeTemplateLangCode)] = routeIdentificationProperties
		}


		delete tree.routeIdentificationProperties
        return routeIdentificationProperties
	}

    /**
    * prepare language connected routes according to their visibility.
    * limit this preparation to the server to prevent multiple preparations.
    *
    * @param refRouteLanguageConnections        object - routeLanguageConnections given by api
    * @param storage                            object - actual storage
    */
    ComponentTree.prototype.prepareRouteLanguageConnections = function(refRouteLanguageConnections, storage){
        if(storage.isServer){

            var isUserPresent = (
                storage.user
                &&
                utils.isFunction(storage.user.statusVisible)
            );
            var referenceTimestamp = (isUserPresent && storage.user.getReferenceTS()) || new Date().toISOString();

            var langCode, type, routes, r, route, visibilityStates, overallVisibility, foundVisibleRoute, overrideType;
            for(langCode in refRouteLanguageConnections || {}){
                for(type in refRouteLanguageConnections[langCode] || {}){
                    routes = refRouteLanguageConnections[langCode][type] || []
                    overallVisibility = true

                    // calculate overallVisibility
                    for(r in routes){
                        route = routes[r]

                        if(overallVisibility){
                            // collect actual route states
                            visibilityStates = {
                                status: !!(
                                    (
                                        isUserPresent
                                        &&
                                        (
                                            (
                                                route.subType === 'layout'
                                                &&
                                                route.status !== 'inactive'
                                            )
                                            ||
                                            (
                                                route.subType !== 'layout'
                                                &&
                                                storage.user.statusVisible(route.status)
                                            )
                                        )
                                        &&
                                        route.templateStatus !== 'inactive'
                                    )
                                    ||
                                    (
                                        !isUserPresent
                                        &&
                                        (
                                            utils.isEmpty(route.status)
                                            ||
                                            route.status === 'active'
                                            ||
                                            route.status === 'preview & active'
                                            ||
                                            route.status === 'invisible'
                                        )
                                        &&
                                        route.templateStatus !== 'inactive'
                                    )
                                ),
                                privilege: !!(
                                    !route.privilegeCode
                                    ||
                                    storage.user.hasAccessTo(route.privilegeCode, route.scope)
                                ),
                                period: !!(
                                    (
                                        isUserPresent
                                        &&
                                        storage.user.statusVisible('preview')
                                    )
                                    ||
                                    (
                                        !route.periodStart
                                        ||
                                        referenceTimestamp >= route.periodStart
                                    )
                                    &&
                                    (
                                        !route.periodEnd
                                        ||
                                        referenceTimestamp <= route.periodEnd
                                    )
                                )
                            };
                            overallVisibility =
                                visibilityStates.status &&
                                visibilityStates.privilege &&
                                visibilityStates.period
                            ;
                        }

                        route.overallVisibility = overallVisibility
                    }

                    // identify first visible route in chain
                    foundVisibleRoute = false
                    for(r = routes.length - 1; r >= 0; r--){
                        route = routes[r]
                        if(route.overallVisibility && route.type !== 'language' && (type === 'connected' || (type === 'home' && (r === (routes.length - 1))))){
                            foundVisibleRoute = true;
							overrideType = ''

                            route.connectionType = ''
                            if(type === 'connected'){
                                if(r === (routes.length - 1)){
                                    route.connectionType = 'connected'
                                } else {
                                    route.connectionType = overrideType = 'connectedParent'
                                }
                            } else if(type === 'home' && r === (routes.length - 1) && route.isHome){
                                route.connectionType = 'home'
                            }

                            refRouteLanguageConnections[langCode][overrideType || type] = route;
							if(type !== 'connected' || refRouteLanguageConnections[langCode].connectedParent){
								// prevent list of connected elements if there was a connected parent only
								if(type !== 'home' && utils.isArray(refRouteLanguageConnections[langCode].connected)){
									delete refRouteLanguageConnections[langCode].connected
								}
                            	break;
							}
                        }
                    }

                    // remove whole type if no visible route has been found
                    if(!foundVisibleRoute){
                        delete refRouteLanguageConnections[langCode][type];
						// remove connectedParent node if necessary
						if(type === 'connected'){
                        	delete refRouteLanguageConnections[langCode].connectedParent;
						}
                    }
                }

                // reset langCodes if no available languageConnection is left
                if(Object.keys(refRouteLanguageConnections[langCode] || {}).length < 1){
                    refRouteLanguageConnections[langCode] = null
                }
            }
        }
    };

	/**
	 * this function returns an object containing all parameters needed to identify the given route.
	 * NOTE: especially when only the routeID is available this is usefully.
	 *
	 * @param   route       				string|int - actual route or routeID
	 * @param   storage     				object - actual storage
	 * @param   routeTemplateCodeName       string - route should be identified via cms_routes.templateCodeName and langCode
	 * @param   routeTemplateLangCode       string - route should be identified via cms_routes.templateCodeName and this langCode
	 * @returns {{fullParamRoute: string, routeID: number, route: (number|string), cacheRoute: string, coreRoute: string}}
	 */
	ComponentTree.prototype.getRouteIdentificationProperties = function(route, storage, routeTemplateCodeName, routeTemplateLangCode){
		let routeID = 0;
		let coreRoute = '';
		let fullParamRoute = '';
		let cacheRoute = storage.request.cacheRoute || '';

		if(route){
			if(route == parseInt(route)){
				routeID = route
			} else {
				fullParamRoute = coreRoute = route
			}

			if(routeID && this.trees[routeID]){
				fullParamRoute = coreRoute = this.extractPath(this.trees[routeID]);
			}
		}

		if(fullParamRoute && (this.routeIdentificationMapping[fullParamRoute] || {}).corePath){
			coreRoute = this.routeIdentificationMapping[fullParamRoute].corePath
		} else if(routeTemplateCodeName){
			const routeIdentificationProperties = this.routeIdentificationMapping[this.getRouteTemplateMappingKey(routeTemplateCodeName, routeTemplateLangCode)] || {}
			if(routeIdentificationProperties.corePath){
				fullParamRoute = coreRoute = routeIdentificationProperties.corePath
			}
			if(!routeID && routeIdentificationProperties.routeID){
				routeID = routeIdentificationProperties.routeID
			}
		}

		return {
			routeID,					// routeID or 0
			route,						// given route identifier (maybe a routeID or a routePath)
			fullParamRoute,				// route potentially including parameters
			coreRoute,					// coreRoute without parameters matched by the api
			cacheRoute,  				// route used for tree- and html-caches. equals essentially coreRoute but may be extended by TEXT_MODE or JSON_MODE query params.
			routeTemplateCodeName,		// cms_routes.templateCodeName
			routeTemplateLangCode,		// langCode of template-route
		};
	};

	/**
	 * this function returns true if the actual route has been built.
	 *
 	 * @param   storage 			object - actual storage
 	 * @param   route				string - route
	 * @param   buildMemory     	object - optional - buildMemory object used to store built trees and rendered html
	 * @return  boolean
	 */
	ComponentTree.prototype.isRouteAvailable = function(storage, route, buildMemory){
		if(buildMemory === undefined || buildMemory === null){
			buildMemory = this;
		}

		var cacheAvailable = (
			buildMemory.trees[route] &&
			buildMemory.trees[route].readyToServeFromCache
		);

		var minFuturePeriodChangeAtIsInFuture = (
			cacheAvailable &&
			(
				!buildMemory.trees[route].minFuturePeriodChangeAt ||
				buildMemory.trees[route].minFuturePeriodChangeAt > storage.user.getReferenceTS()
			)
		);

		if(!appConfig.cache.preWarmRoutes && !storage.user.data.isPrewarmProcess && !minFuturePeriodChangeAtIsInFuture){
			storage.request.forceMinFuturePeriodChangeAtIndicatedUpdate = true;
		}

		return (
			cacheAvailable &&
			!storage.user.data.isPrewarmProcess &&
			minFuturePeriodChangeAtIsInFuture
		);
	};

	/**
	 * this function is used to render a previously built tree identified by the given tree name.
	 * it returns the rendered string of the whole tree and is used in server-side code only.
	 *
	 * @param   tree    			string | object - name of the tree or tree data
	 * @param   storage 			object - actual storage
     * @param   routeParams			object - parameters defined by the actual route-call
     * @param   refRenderOptions	object - these options will be used to transport extra flags to the callee.
	 * @param   buildMemory     	object - optional - buildMemory object used to store built trees and rendered html
	 * @returns string  rendered html code
	 */
	ComponentTree.prototype.render = function(tree, storage, routeParams, refRenderOptions, buildMemory, renderMemory, writeHtmlChache){
		var fallbackRefRenderOptions = {};
		if(!renderMemory) renderMemory = {};

		if(refRenderOptions == undefined) {
			refRenderOptions = fallbackRefRenderOptions;
		}
		// buildMemory fallback just in case the build process should not memorize the actual built tree and rendered html
		if(buildMemory === undefined || buildMemory === null){
			buildMemory = storage.buildMemory = {};
			if(appConfig.cache.storeBuildMemoryPermanently && storage.user.cacheUsageGranted()){
				buildMemory.trees 	= this.trees;
				buildMemory.mapping = this.mapping;
				buildMemory.html 	= this.html;
			}
		}
		if(!buildMemory.trees) 		buildMemory.trees = {};
		if(!buildMemory.mapping) 	buildMemory.mapping = {};
		if(!buildMemory.html) 		buildMemory.html = {};

		refRenderOptions.cachedHtmlUsed = false;
		if(utils.isString(tree)){
			// cache route may differ from real route (e.g., TEXT_MODE usage)
			var cachedRoute = (storage.request || {}).cacheRoute || tree;

			if(!buildMemory.html[cachedRoute]){
				buildMemory.html[cachedRoute] = {};
			}

			// skip renderLeaf if possible
			if(appConfig.cache.reuseCachedHtml && buildMemory.html[cachedRoute].readyToServeFromCache && buildMemory.html[cachedRoute].wasCacheable && !storage.user.data.isPrewarmProcess && !storage.request.forceMinFuturePeriodChangeAtIndicatedUpdate){
				if(!writeHtmlChache){
					utils.refSimpleCopy(renderMemory, buildMemory.html[cachedRoute]);
				}
				return buildMemory.html[cachedRoute].rendered;
			}

			// copy rendered memory to prevent race-conditions between a render process and a potential render-cache-user.
			utils.refSimpleCopy(renderMemory, buildMemory.html[cachedRoute]);

			// renderLeaf according to potential partial html caches
			if(this.renderLeaf(buildMemory.trees[tree], tree, storage, routeParams, buildMemory, renderMemory)){
				var readyToServeFromCache = (refRenderOptions.finalRenderCall || false) && renderMemory.wasCacheable;

				if(readyToServeFromCache){
					this.beautifyHtml(renderMemory);
				}

				renderMemory.readyToServeFromCache = readyToServeFromCache;
				// if a html cache is marked as not ready the build will be done again too.
				// this is the reason why the render process is allowed to define if a build tree is ready to be served from cache or not.
				if(buildMemory.trees[cachedRoute]){
					buildMemory.trees[cachedRoute].readyToServeFromCache = readyToServeFromCache;
				}

				if(writeHtmlChache !== false){
					buildMemory.html[cachedRoute] = renderMemory;
				}

				return renderMemory.rendered;
			}
		}
		else if(!utils.isEmpty(tree)){
			var renderMemory = {};
			if(this.renderLeaf(tree, undefined, storage, routeParams, buildMemory, renderMemory)){
				return renderMemory.rendered;
			}
		}

		console.error('tree could not be rendered: ' + tree);
		return '';
	};

	/**
	 * this function is used to render one leaf within the component tree and all of its' subComponents.
	 *
	 * @param   leaf                object - leaf (component data)
	 * @param   rootRoute           string - which root route will actually be rendered
	 * @param   storage             object - actual storage
	 * @param   routeParams			object - parameters defined by the actual route-call
	 * @param   buildMemory     	object - optional - buildMemory object used to store built trees and rendered html
	 * @param   renderMemory     	object - renderMemory object used to store rendered html. one may keep it for caching features or ignore it after usage so the gc can clean it up.
	 * @param   routeIsCachable    	boolean - default: true - this flag is for internal use only and will be set when a route's isCacheable flag is set to false.
	 * @returns string              rendered leaf html
	 */
	ComponentTree.prototype.renderLeaf = function(leaf, rootRoute, storage, routeParams, buildMemory, renderMemory, routeIsCachable){
		// prevent errors according to erroneous leaf definitions
		if(utils.isCollection(leaf)){

			// init
			var subRouteFound = false;
			if(!renderMemory) renderMemory = {};

			// check if subRoute has been found
			if(leaf.type === 'component' && typeof(leaf.parentComponentInstanceID) === 'string' && leaf.parentComponentInstanceID.substring(0, 1) === '/' && leaf.parentComponentInstanceID != rootRoute){
				subRouteFound = true;
				rootRoute = leaf.parentComponentInstanceID;
			}

			// check if route is cachable
			if(leaf.type === 'route' && routeIsCachable === undefined && !leaf.isCacheable){
				routeIsCachable = false;
			}

			if(!renderMemory.wasCacheable || !renderMemory.rendered || routeIsCachable === false || storage.user.data.isPrewarmProcess || storage.request.forceMinFuturePeriodChangeAtIndicatedUpdate) {
				renderMemory.wasCacheable 		= appConfig.cache.reuseCachedHtml && routeIsCachable !== false;
				renderMemory.inclusionPerformed = false;
				renderMemory.rendered 			= '';
				renderMemory.children 			= {};
				renderMemory.renderedChildren 	= '';
				renderMemory.renderedSections 	= {};

				// handle proxyCacheScope
				let proxyCacheScope
				if(
					storage.isServer &&
					storage.proxyCacheController &&
					(
						leaf.type === 'route'
						||
						leaf.type === 'component'
					)
				){
					proxyCacheScope = storage.proxyCacheController.getScope(leaf, 'render')
					storage.proxyCacheController.scopeStart(proxyCacheScope)
				}

				var childIndex, child, childRenderMemory;
				for (childIndex in leaf.children) {
					// be aware of empty nodes according to privileges and states after build
					if((child = leaf.children[childIndex])){
						renderMemory.children[childIndex] = {};
						childRenderMemory = renderMemory.children[childIndex];
						this.renderLeaf(child, rootRoute, storage, routeParams, buildMemory, childRenderMemory, routeIsCachable);

						if(child.type === 'section'){
							renderMemory.renderedSections[child.code] = childRenderMemory.rendered;
						}
						else {
							renderMemory.renderedChildren += childRenderMemory.rendered;
						}

						renderMemory.wasCacheable 			= renderMemory.wasCacheable && childRenderMemory.wasCacheable;
						renderMemory.inclusionPerformed 	= renderMemory.inclusionPerformed || childRenderMemory.inclusionPerformed;
					}
				}

				// render leaf according to it's type
				if(leaf.type === 'route'){
					renderMemory.wasCacheable 	= leaf.isCacheable && !leaf.privilegeCode && renderMemory.wasCacheable;
					renderMemory.rendered 		= renderMemory.renderedChildren;
				}
				else if(leaf.type === 'section'){
					// since components may decide not to be built, their parents (even if they are sections) have to transport if this tree part wasCacheable or not.
					if(leaf.isCacheable === false || !!leaf.privilegeCode) renderMemory.wasCacheable = false;
					renderMemory.rendered = {
						tagInclusive: componentList.templates.section({ name: leaf.code, id: leaf.sectionID, content: renderMemory.renderedChildren }),
						tagExclusive: renderMemory.renderedChildren
					}
				}
				else if(leaf instanceof Component){
					// reset inclusionKey
					leaf.actualInclusionKey = 1;

					// render component
					leaf.renderMemory 			= renderMemory;
					renderMemory.rendered 		= leaf.render(storage, routeParams);
					renderMemory.wasCacheable 	= renderMemory.wasCacheable && (leaf.config || {}).isCacheable !== false && !leaf.privilegeCode;
					delete leaf.renderMemory;

					// save included subRoutes if necessary
					if(subRouteFound){
						// TODO: CHECK THIS IN CASE OF TEXT_MODE
						buildMemory.html[rootRoute] = renderMemory;
					}

					// update inclusionPerformed flag if necessary
					renderMemory.inclusionPerformed = renderMemory.inclusionPerformed || leaf.inclusionPerformed;
				}

				// handle proxyCacheScope
				if(proxyCacheScope){
					storage.proxyCacheController.scopeEnd(proxyCacheScope)
				}
			}

			return true;
		}

		throw new Error('FEC_RENDER_LEAF_INVALID_LEAF_FOUND');
	};

	/**
	 * prepares html right before it is written to the cache.
	 *
	 * @param renderMemory		object - render object just like it is returned by ComponentTree.prototype.render method.
	 * @void
	 */
	ComponentTree.prototype.beautifyHtml = function(renderMemory){
		if(renderMemory.rendered && appConfig.cache.minifyHtmlCache && utils.htmlMinify){
			renderMemory.rendered = utils.htmlMinify(renderMemory.rendered, appConfig.cache.minifyHtmlCacheOptions);
		}
	};


	///////////////////////////////////////////////
	///// HELPERS
	///////////////////////////////////////////////

	/**
	 * return root node of given leaf
	 *
	 * @param   leaf        object - leaf within component tree
	 * @returns             {} - root leaf
	 */
	ComponentTree.prototype.getRoot = function(leaf){
		if(!utils.isEmpty(leaf.parentComponentIndex) || leaf.parentComponentIndex === 0) return this.getRoot(this.lookup[leaf.parentComponentIndex]);
		return leaf;
	};

	/**
	 * check if the given leaf may be built.
     *
	 * @param leaf					object - fec tree leaf
	 * @param storage				object - actual storage
	 * @param isBrowser				boolean - isClient or not?
	 * @param returnBooleanResult	boolean - if this flag is set to true the result will be cumulated into a simple true or false. a little more detailed result object will be returned otherwise.
	 * @returns {{referenceTimestamp: (string), isUserPresent: boolean, states: {period: boolean, privilege: boolean, status: boolean}}|boolean}
	 */
	ComponentTree.prototype.getLeafBuildStates = function(leaf, storage, isBrowser, returnBooleanResult = false){
		const isUserPresent = (
			storage.user
			&&
			utils.isFunction(storage.user.statusVisible)
		);
		const referenceTimestamp = (isUserPresent && storage.user.getReferenceTS()) || new Date().toISOString();
		const states = {
			status: !!(
				(
					isUserPresent
					&&
					(
						(
							leaf.subType === 'layout'
							&&
							leaf.status !== 'inactive'
						)
						||
						(
							leaf.subType !== 'layout'
							&&
							storage.user.statusVisible(leaf.status)
						)
					)
					&&
					leaf.templateStatus !== 'inactive'
				)
				||
				(
					!isUserPresent
					&&
					(
						utils.isEmpty(leaf.status)
						||
						leaf.status === 'active'
						||
						leaf.status === 'preview & active'
						||
						leaf.status === 'invisible'
					)
					&&
					leaf.templateStatus !== 'inactive'
				)
			),
			privilege: !!(
				isBrowser
				||
				(
					!leaf.privilegeCode
					||
					storage.user.hasAccessTo(leaf.privilegeCode, leaf.scope)
				)
			),
			period: !!(
				(
					isUserPresent
					&&
					storage.user.statusVisible('preview')
				)
				||
				(
					!leaf.periodStart
					||
					referenceTimestamp >= leaf.periodStart
				)
				&&
				(
					!leaf.periodEnd
					||
					referenceTimestamp <= leaf.periodEnd
				)
			)
		};

		if(returnBooleanResult){
			return states.status && states.period && states.privilege
		}

		return {
			isUserPresent,
			referenceTimestamp,
			states
		}
	}

	/**
	 * returns route core mapping key for routes via routeTemplateCodeName.
	 *
	 * @param   routeTemplateCodeName       string - cms_routes.templateCodeName
	 * @param   routeTemplateLangCode       string - langCode
	 * @returns             {} - root leaf
	 */
	ComponentTree.prototype.getRouteTemplateMappingKey = function(routeTemplateCodeName, routeTemplateLangCode){
		return `~template~${routeTemplateCodeName || 'NO_TEMPLATE_CODE_NAME'}~${routeTemplateLangCode || 'NO_LANG'}~`
	};


	module.exports = ComponentTree;
